import {Field, Form, Formik } from "formik";
import React, { useState, useEffect, useRef} from "react";
import Button from 'react-bootstrap/Button';
import { useDispatch } from 'react-redux';
import { useParams } from "react-router-dom";
import EditIcon from '@material-ui/icons/Edit'
import { iWatch } from "../../../services/iPhoneApiService";
import { addToCart } from "../../../store/actions/cart";
import { isEmpty } from "../../../validation/index";
import LoaderSpinner from "../../Loader/loaderSpinner";
import { v4 as uuidv4 } from 'uuid';
import { WindowsFilled } from "@ant-design/icons";


const deviceList1 = [
    {
        devicePhoto: "https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/apple-watch-series-10.jpg.webp",
        displayName: "Apple Watch (Series 10)",
        label: "Apple Watch (Series 10)",
        deviceDetail: [
            {
                TypeOfWathches:  ['GPS', 'GPS+']
            },
            {
                TypeofCaseWatchHave: ['Aluminium Case', 'Titanium Case']
            },
            {
                SizeofyourWatch:  ['42mm', "46mm"]
            },
            {
                TypeOfBands:['Solo Loop','Sport Band','Sport Loop','Brainded Solo Loop','Link Bracelet','Magnetic Link','Melanese Loop', "Not sure"]
            },
            {
                Condition: [{ name: 'Brand New', label: 'Watch is still in factory original packaging. Comes with the box and all accessories sealed/untouched.' }, { name: 'Flaw-less', label: 'Watch and band have absolutely no scratches, scuffs or other marks. Looks brand new.' }, { name: 'Good', label: 'Watch Shows light to moderate signs of wear. Contains few light scratches, dings, or wear on screen and band.' }, { name: 'Fair', label: 'Watch shows moderate to excessive signs of wear. Contains heavy scratches and/or dents on screen and band.' }, { name: 'Broken', label: 'Watch has deep cracks or broken parts on either screen or band of the item.' },]
            }
        ],
        imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/apple-watch-series-10.jpg.webp"
    },
    {
        devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/iwatch-ultra-2.png',
        displayName: "Apple Watch Ultra 2",
        label: "Apple Watch Ultra 2",
        deviceDetail: [
            {
                TypeOfWathches: []
            },
            {
                TypeofCaseWatchHave: []
            },
            {
                SizeofyourWatch: []
            },
            {
                TypeOfBands:  ['Alpine loop', 'Trail loop','Ocean Band',"Not sure"]
            },
            {
                Condition: [{ name: 'Brand New', label: 'Watch is still in factory original packaging. Comes with the box and all accessories sealed/untouched.' }, { name: 'Flaw-less', label: 'Watch and band have absolutely no scratches, scuffs or other marks. Looks brand new.' }, { name: 'Good', label: 'Watch Shows light to moderate signs of wear. Contains few light scratches, dings, or wear on screen and band.' }, { name: 'Fair', label: 'Watch shows moderate to excessive signs of wear. Contains heavy scratches and/or dents on screen and band.' }, { name: 'Broken', label: 'Watch has deep cracks or broken parts on either screen or band of the item.' },]
            }
        ],
        imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/iwatch-ultra-2.png"
    },
    {
        devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/iwatch-series-9.jpg.webp',
        displayName: "Apple Watch (Series 9)",
        label: "Apple Watch (Series 9)",
        deviceDetail: [
            {
                TypeOfWathches: ['GPS', 'GPS+']
            },
            {
                TypeofCaseWatchHave: ['Aluminium Case', 'Stainless-Steel Case']
            },
            {
                SizeofyourWatch: ['41mm', "45mm"]
            },
            {
                TypeOfBands: ['Solo Loop','Sport Band','Sport Loop','Brainded Solo Loop','Link Bracelet','Magnetic Link','Melanese Loop','Modern Buckle',"Not sure"]
            },
            {
                Condition: [{ name: 'Brand New', label: 'Watch is still in factory original packaging. Comes with the box and all accessories sealed/untouched.' }, { name: 'Flaw-less', label: 'Watch and band have absolutely no scratches, scuffs or other marks. Looks brand new.' }, { name: 'Good', label: 'Watch Shows light to moderate signs of wear. Contains few light scratches, dings, or wear on screen and band.' }, { name: 'Fair', label: 'Watch shows moderate to excessive signs of wear. Contains heavy scratches and/or dents on screen and band.' }, { name: 'Broken', label: 'Watch has deep cracks or broken parts on either screen or band of the item.' },]
            }
        ],
        imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/iwatch-series-9.jpg.webp"
    },
    {
        devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/iwatch-ultra.jpg.webp',
        displayName: "Apple Watch Ultra",
        label: "Apple Watch Ultra",
        deviceDetail: [
            {
                TypeOfWathches: []
            },
            {
                TypeofCaseWatchHave: []
            },
            {
                SizeofyourWatch: []
            },
            {
                TypeOfBands: ['Alpine loop', 'Trail loop','Ocean Band',"Not sure"]
            },
            {
                Condition: [{ name: 'Brand New', label: 'Watch is still in factory original packaging. Comes with the box and all accessories sealed/untouched.' }, { name: 'Flaw-less', label: 'Watch and band have absolutely no scratches, scuffs or other marks. Looks brand new.' }, { name: 'Good', label: 'Watch Shows light to moderate signs of wear. Contains few light scratches, dings, or wear on screen and band.' }, { name: 'Fair', label: 'Watch shows moderate to excessive signs of wear. Contains heavy scratches and/or dents on screen and band.' }, { name: 'Broken', label: 'Watch has deep cracks or broken parts on either screen or band of the item.' },]
            }
        ],
        imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/iwatch-ultra.jpg.webp"
    },
    {
        devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/iwatch-se-2nd-gen.jpg.webp',
        displayName: "Apple Watch (SE) 2nd Gen.",
        label: "Apple Watch (SE) 2nd Gen.",
        deviceDetail: [
            {
                TypeOfWathches: ['GPS', 'GPS+']
            },
            {
                TypeofCaseWatchHave: ['Aluminium Case', 'Stainless-Steel Case', 'Ceramic Case']
            },
            {
                SizeofyourWatch: ['40mm', "44mm"]
            },
            {
                TypeOfBands: ['Solo Loop','Sport Band','Sport Loop','Brainded Solo Loop','Link Bracelet','Magnetic Link','Melanese Loop','Modern Buckle',"Not sure"]
            },
            {
                Condition: [{ name: 'Brand New', label: 'Watch is still in factory original packaging. Comes with the box and all accessories sealed/untouched.' }, { name: 'Flaw-less', label: 'Watch and band have absolutely no scratches, scuffs or other marks. Looks brand new.' }, { name: 'Good', label: 'Watch Shows light to moderate signs of wear. Contains few light scratches, dings, or wear on screen and band.' }, { name: 'Fair', label: 'Watch shows moderate to excessive signs of wear. Contains heavy scratches and/or dents on screen and band.' }, { name: 'Broken', label: 'Watch has deep cracks or broken parts on either screen or band of the item.' },]
            }
        ],
        imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/iwatch-se-2nd-gen.jpg.webp"
    },
    {
        devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/iwatch-se-2nd-gen.jpg.webp',
        displayName: "Apple Watch (SE) 2nd Gen.",
        label: "Apple Watch (SE) 2nd Gen.",
        deviceDetail: [
            {
                TypeOfWathches: ['GPS', 'GPS+']
            },
            {
                TypeofCaseWatchHave: ['Aluminium Case', 'Stainless-Steel Case', 'Ceramic Case']
            },
            {
                SizeofyourWatch: ['40mm', "44mm"]
            },
            {
                TypeOfBands: ['Solo Loop','Sport Band','Sport Loop','Brainded Solo Loop','Link Bracelet','Magnetic Link','Melanese Loop','Modern Buckle',"Not sure"]
            },
            {
                Condition: [{ name: 'Brand New', label: 'Watch is still in factory original packaging. Comes with the box and all accessories sealed/untouched.' }, { name: 'Flaw-less', label: 'Watch and band have absolutely no scratches, scuffs or other marks. Looks brand new.' }, { name: 'Good', label: 'Watch Shows light to moderate signs of wear. Contains few light scratches, dings, or wear on screen and band.' }, { name: 'Fair', label: 'Watch shows moderate to excessive signs of wear. Contains heavy scratches and/or dents on screen and band.' }, { name: 'Broken', label: 'Watch has deep cracks or broken parts on either screen or band of the item.' },]
            }
        ],
        imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/iwatch-se-2nd-gen.jpg.webp"
    }, {
        devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/apple_iwatch_se_1st_gen.jpeg',
        displayName: "Apple Watch (SE) 1st Gen.",
        label: "Apple Watch (SE) 1st Gen.",
        deviceDetail: [
            {
                TypeOfWathches: ['GPS', 'GPS+']
            },
            {
                TypeofCaseWatchHave: ['Aluminium Case', 'Stainless-Steel Case']
            },
            {
                SizeofyourWatch: ['40mm']
            },
            {
                TypeOfBands: ['Solo Loop','Sport Band','Sport Loop','Brainded Solo Loop','Link Bracelet','Magnetic Link','Melanese Loop','Modern Buckle',"Not sure"]
            },
            {
                Condition: [{ name: 'Brand New', label: 'Watch is still in factory original packaging. Comes with the box and all accessories sealed/untouched.' }, { name: 'Flaw-less', label: 'Watch and band have absolutely no scratches, scuffs or other marks. Looks brand new.' }, { name: 'Good', label: 'Watch Shows light to moderate signs of wear. Contains few light scratches, dings, or wear on screen and band.' }, { name: 'Fair', label: 'Watch shows moderate to excessive signs of wear. Contains heavy scratches and/or dents on screen and band.' }, { name: 'Broken', label: 'Watch has deep cracks or broken parts on either screen or band of the item.' },]
            }
        ],
        imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/apple_iwatch_se_1st_gen.jpeg"
    },
    {
        devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/iwatch-series-8.jpg.webp',
        displayName: "Apple Watch (Series 8)",
        label: "Apple Watch (Series 8)",
        deviceDetail: [
            {
                TypeOfWathches: ['GPS', 'GPS+']
            },
            {
                TypeofCaseWatchHave: ['Aluminium Case', 'Stainless-Steel Case']
            },
            {
                SizeofyourWatch: ['41mm', "45mm"]
            },
            {
                TypeOfBands: ['Solo Loop','Sport Band','Sport Loop','Brainded Solo Loop','Link Bracelet','Magnetic Link','Melanese Loop','Modern Buckle',"Not sure"]
            },
            {
                Condition: [{ name: 'Brand New', label: 'Watch is still in factory original packaging. Comes with the box and all accessories sealed/untouched.' }, { name: 'Flaw-less', label: 'Watch and band have absolutely no scratches, scuffs or other marks. Looks brand new.' }, { name: 'Good', label: 'Watch Shows light to moderate signs of wear. Contains few light scratches, dings, or wear on screen and band.' }, { name: 'Fair', label: 'Watch shows moderate to excessive signs of wear. Contains heavy scratches and/or dents on screen and band.' }, { name: 'Broken', label: 'Watch has deep cracks or broken parts on either screen or band of the item.' },]
            }
        ],
        imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/iwatch-series-8.jpg.webp"
    },
    {
        devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/iwatch-series-7.jpeg.webp',
        displayName: "Apple Watch (Series 7)",
        label: "Apple Watch (Series 7)",
        deviceDetail: [
            {
                TypeOfWathches: ['GPS', 'GPS+']
            },
            {
                TypeofCaseWatchHave: ['Aluminium Case', 'Stainless-Steel Case',  'Titanium Case']
            },
            {
                SizeofyourWatch: ['41mm', "45mm"]
            },
            {
                TypeOfBands: ['Solo Loop','Sport Band','Sport Loop','Brainded Solo Loop','Link Bracelet','Magnetic Link','Melanese Loop','Modern Buckle',"Not sure"]
            },
            {
                Condition: [{ name: 'Brand New', label: 'Watch is still in factory original packaging. Comes with the box and all accessories sealed/untouched.' }, { name: 'Flaw-less', label: 'Watch and band have absolutely no scratches, scuffs or other marks. Looks brand new.' }, { name: 'Good', label: 'Watch Shows light to moderate signs of wear. Contains few light scratches, dings, or wear on screen and band.' }, { name: 'Fair', label: 'Watch shows moderate to excessive signs of wear. Contains heavy scratches and/or dents on screen and band.' }, { name: 'Broken', label: 'Watch has deep cracks or broken parts on either screen or band of the item.' },]
            }
        ],
        imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/iwatch-series-7.jpeg.webp"
    },{
        devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/iwatch-series-6.jpg.webp',
        displayName: "Apple Watch (Series 6)",
        label: "Apple Watch (Series 6)",
        deviceDetail: [
            {
                TypeOfWathches: ['GPS', 'GPS+']
            },
            {
                TypeofCaseWatchHave: ['Aluminium Case', 'Stainless-Steel Case','Titanium Case']
            },
            {
                SizeofyourWatch: ['40mm', "44mm"]
            },
            {
                TypeOfBands: ['Solo Loop','Sport Band','Sport Loop','Brainded Solo Loop','Link Bracelet','Magnetic Link','Melanese Loop','Modern Buckle',"Not sure"]
            },
            {
                Condition: [{ name: 'Brand New', label: 'Watch is still in factory original packaging. Comes with the box and all accessories sealed/untouched.' }, { name: 'Flaw-less', label: 'Watch and band have absolutely no scratches, scuffs or other marks. Looks brand new.' }, { name: 'Good', label: 'Watch Shows light to moderate signs of wear. Contains few light scratches, dings, or wear on screen and band.' }, { name: 'Fair', label: 'Watch shows moderate to excessive signs of wear. Contains heavy scratches and/or dents on screen and band.' }, { name: 'Broken', label: 'Watch has deep cracks or broken parts on either screen or band of the item.' },]
            }
        ],
        imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/iwatch-series-6.jpg.webp"
    },
    {
        devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/iwatch-series-5.jpg.webp',
        displayName: "Apple Watch (Series 5)",
        label: "Apple Watch (Series 5)",
        deviceDetail: [
            {
                TypeOfWathches:['GPS', 'GPS+']
            },
            {
                TypeofCaseWatchHave: ['Aluminium Case', 'Stainless-Steel Case','Titanium Case','Ceramic Case']
            },
            {
                SizeofyourWatch: ['40mm', "44mm"]
            },
            {
                TypeOfBands: ['Sport Band','Sport Loop','Leather Loop','Link Bracelet','Melanese Loop','Modern Buckle',"Not sure"]
            },
            {
                Condition: [{ name: 'Brand New', label: 'Watch is still in factory original packaging. Comes with the box and all accessories sealed/untouched.' },
                 { name: 'Flaw-less', label: 'Watch and band have absolutely no scratches, scuffs or other marks. Looks brand new.' },
                  { name: 'Good', label: 'Watch Shows light to moderate signs of wear. Contains few light scratches, dings, or wear on screen and band.' },
                   { name: 'Fair', label: 'Watch shows moderate to excessive signs of wear. Contains heavy scratches and/or dents on screen and band.' }, 
                   { name: 'Broken', label: 'Watch has deep cracks or broken parts on either screen or band of the item.' },]
            }
        ],
        imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/iwatch-series-5.jpg.webp"
    },
    {
        devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/apple-watch-series-4.webp',
        displayName: "Apple Watch (Series 4)",
        label: "Apple Watch (Series 4)",
        deviceDetail: [
            {
                TypeOfWathches:['GPS', 'GPS+']
            },
            {
                TypeofCaseWatchHave: ['Aluminium Case', 'Stainless-Steel Case','Titanium Case']
            },
            {
                SizeofyourWatch: ['40mm', "44mm"]
            },
            {
                TypeOfBands: ['Sport Band','Sport Loop','Leather Loop','Link Bracelet','Melanese Loop','Modern Buckle',"Not sure"]
            },
            {
                Condition: [{ name: 'Brand New', label: 'Watch is still in factory original packaging. Comes with the box and all accessories sealed/untouched.' },
                 { name: 'Flaw-less', label: 'Watch and band have absolutely no scratches, scuffs or other marks. Looks brand new.' },
                  { name: 'Good', label: 'Watch Shows light to moderate signs of wear. Contains few light scratches, dings, or wear on screen and band.' },
                   { name: 'Fair', label: 'Watch shows moderate to excessive signs of wear. Contains heavy scratches and/or dents on screen and band.' }, 
                   { name: 'Broken', label: 'Watch has deep cracks or broken parts on either screen or band of the item.' },]
            }
        ],
        imagePath: "https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/apple-watch-series-4.webp"
    }
]

const IWatch = (props) => {
    const dispatch = useDispatch();
    const [selectedDevice, setSelectedDevice] = useState()
    const [offers, setOffers] = useState()
    const [imagePath, setImagePath] = useState()
    const [isLoader, setIsLoader] = useState(false)
    const [isShowButton, setIsShowButton] = useState(false)
    const [isTypeOfWathches, setIsTypeOfWathches] = useState(false)
    const [isUltra, setIsUltra]= useState(false)
    const [isIncludesBand, setIsIncludesBand] = useState(false)
    const [isWatch_functionalYes, setIsWatch_functionalYes] = useState(false)
    const [isIncludesBandYes, setIsIncludesBandYes] = useState(false)
    const uuid = uuidv4()
    const [isBrokenOrNo, setIsBrokenOrNo] = useState(false)
    const [isBrokenFiled, setIsBrokenFiled] = useState(false)
    let { model } = useParams();

    useEffect(() => {
        if (model) {
            deviceList1.filter(x => {
                if (model === 'Apple Watch Ultra 2'||'Apple Watch Ultra') {
                    setIsTypeOfWathches(false)
                } else {
                    setIsTypeOfWathches(true)
                }
                if (x.label === model) {
                    setSelectedDevice([x])
                    setImagePath(x.imagePath);
                }
            })
        }
    }, [model])
    

    const selectDevice = (obj) => {
       
        props.history.push(`/iwatch/${obj.label}`)
        window.location.reload()
       //setSelectedDevice([obj]);
       //setImagePath(obj.imagePath);
       
    }
    const section1Ref=useRef()
        const scrollToSection = (ref) => {
            ref.current?.scrollIntoView({ behavior: "smooth", block: "center" });
        };

    const handelSubmits = (value) => {
        setIsLoader(true);
        //const condition = value.iwatch_condition === 'Brand New' ? 'Brand New' : value.iwatch_condition === 'Flaw-less' ? 'Like New' : value.iwatch_condition === 'Good' ? 'Good' : value.iwatch_condition === 'Fair' ? 'Fair' : 'Broken'
        const iwatch_band = value.iwatch_bands ? value.iwatch_bands : value.iwatch_band
        const iwatch_box = value.iwatch_box ? 'Yes' : 'No%'
        const iwatch_powercord = value.iwatch_powercord ? 'Yes' : 'No%'
       // const iwatch_carrier = value.iwatch_carrier === 'GPS+' ? 'GPS %2B Cellular' : value.iwatch_carrier === 'GPS' ? 'GPS' : ''
        const deviceImage= selectedDevice[0].devicePhoto
        setImagePath(deviceImage)
        const iWatchData = {
            iwatch_model: selectedDevice[0].label,
            iwatch_carrier : value.iwatch_carrier,
            iwatch_edition_casing: value.iwatch_edition_casing,
            iwatch_size: value.iwatch_size,
            iwatch_band:iwatch_band,
            iwatch_condition: value.iwatch_condition,
            iwatch_functional: value.iwatch_functional,
            iwatch_powercord:iwatch_powercord,
            iwatch_box:iwatch_box
        }
        let customAmount = 0;
        //console.log(iWatchData)
        //console.log(value.iwatch_condition)
if(selectedDevice[0].label==="Apple Watch Ultra"){
            iWatchData.iwatch_carrier=  ""
            iWatchData.iwatch_edition_casing=""
            iWatchData.iwatch_size=  ""
            iWatchData.iwatch_band= ""
            iWatchData.iwatch_functional= ""
            iWatchData.iwatch_box= ""
            iWatchData.iwatch_powercord= ""
            
            
            if(iWatchData.iwatch_condition === "Brand New"){
                customAmount=customAmount
            }
            if(iWatchData.iwatch_condition==="Like New"){
                
                if(iwatch_band==="No"){
                    customAmount-=60
                }
                if(iwatch_band==="Alpine loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Ocean Band"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Trail loop"){
                    customAmount=customAmount
                }
                if(iwatch_box==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_box==="No%"){
                    customAmount-=10
                }
                if(iwatch_powercord==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_powercord==="No%"){
                    customAmount-=40
                } if(value.iwatch_functional==="Yes"){
                    customAmount=customAmount
                }
                if(value.iwatch_functional==="No"){
                    customAmount-=customAmount
                }
                
            }
            if(iWatchData.iwatch_condition==="Good"){
                
                if(iwatch_band==="No"){
                    customAmount-=60
                }
                if(iwatch_band==="Alpine loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Ocean Band"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Trail loop"){
                    customAmount=customAmount
                }
                if(iwatch_box==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_box==="No%"){
                    customAmount-=10
                }
                if(iwatch_powercord==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_powercord==="No%"){
                    customAmount-=40
                } if(value.iwatch_functional==="Yes"){
                    customAmount=customAmount
                }
                if(value.iwatch_functional==="No"){
                    customAmount-=customAmount
                }
        }
        if(iWatchData.iwatch_condition==="Fair"){
                
            if(iwatch_band==="No"){
                customAmount-=60
            }
            if(iwatch_band==="Alpine loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Ocean Band"){
                customAmount=customAmount
            }
            if(iwatch_band==="Trail loop"){
                customAmount=customAmount
            }
            if(iwatch_box==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_box==="No%"){
                customAmount-=10
            }
            if(iwatch_powercord==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_powercord==="No%"){
                customAmount-=40
            } if(value.iwatch_functional==="Yes"){
                customAmount=customAmount
            }
            if(value.iwatch_functional==="No"){
                customAmount-=customAmount
            }
        }
        if(iWatchData.iwatch_condition==="Defective"){
                
            if(iwatch_band==="No"){
                customAmount-=60
            }
            if(iwatch_band==="Alpine loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Ocean Band"){
                customAmount=customAmount
            }
            if(iwatch_band==="Trail loop"){
                customAmount=customAmount
            }
            if(iwatch_box==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_box==="No%"){
                customAmount-=10
            }
            if(iwatch_powercord==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_powercord==="No%"){
                customAmount-=40
            } if(value.iwatch_functional==="Yes"){
                customAmount=customAmount
            }
            if(value.iwatch_functional==="No"){
                customAmount-=customAmount
            }
        }

            if(iWatchData.iwatch_condition==="Broken"){
                    customAmount-=customAmount
                
            }
        }
else if(selectedDevice[0].label==="Apple Watch (Series 10)"){
            iWatchData.iwatch_carrier=  "GPS"
            iWatchData.iwatch_edition_casing="Aluminium Case"
            iWatchData.iwatch_size=  "42mm"
            iWatchData.iwatch_band= ""
            iWatchData.iwatch_functional= ""
            iWatchData.iwatch_box= ""
            iWatchData.iwatch_powercord= ""
            
            
            if(iWatchData.iwatch_condition === "Brand New"){
                customAmount=customAmount
            
                if(value.iwatch_edition_casing==="Titanium Case"){
                    customAmount+=180
                }
                if(value.iwatch_size==="46mm"){
                    customAmount+=15
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=20
                }
                
            }
            if(iWatchData.iwatch_condition==="Like New")
                {
                if(value.iwatch_edition_casing==="Titanium Case"){
                    customAmount+=180
                }
                if(value.iwatch_size==="46mm"){
                    customAmount+=15
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=20
                }
                if(iwatch_band==="No"){
                    customAmount-=40
                }
                if(iwatch_band==="Solo loop"){
                    customAmount=customAmount

                }
                if(iwatch_band==="Sport Band"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Brainded Solo Loop"){
                    customAmount+=15
                }
                if(iwatch_band==="Link Bracelet"){
                    customAmount+=20
                }
                if(iwatch_band==="Magnetic Link"){
                    customAmount+=15
                }
                if(iwatch_band==="Melanese Loop"){
                    customAmount+=15
                }
                
                if(iwatch_box==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_box==="No%"){
                    customAmount-=10
                }
                if(iwatch_powercord==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_powercord==="No%"){
                    customAmount-=40
                } if(value.iwatch_functional==="Yes"){
                    customAmount=customAmount
                }
                if(value.iwatch_functional==="No"){
                    customAmount-=customAmount
                }
                
            }
            if(iWatchData.iwatch_condition==="Good"){
                if(value.iwatch_edition_casing==="Titanium Case"){
                    customAmount+=180
                }
                if(value.iwatch_size==="46mm"){
                    customAmount+=15
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=20
                }
                if(iwatch_band==="No"){
                    customAmount-=40
                }
                if(iwatch_band==="Solo loop"){
                    customAmount=customAmount

                }
                if(iwatch_band==="Sport Band"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Brainded Solo Loop"){
                    customAmount+=15
                }
                if(iwatch_band==="Link Bracelet"){
                    customAmount+=20
                }
                if(iwatch_band==="Magnetic Link"){
                    customAmount+=15
                }
                if(iwatch_band==="Melanese Loop"){
                    customAmount+=15
                }
                
                if(iwatch_box==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_box==="No%"){
                    customAmount-=10
                }
                if(iwatch_powercord==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_powercord==="No%"){
                    customAmount-=40
                }  if(value.iwatch_functional==="Yes"){
                    customAmount=customAmount
                }
                if(value.iwatch_functional==="No"){
                    customAmount-=customAmount
                }
                
            }
        if(iWatchData.iwatch_condition==="Fair"){
            if(value.iwatch_edition_casing==="Titanium Case"){
                customAmount+=180
            }
            if(value.iwatch_size==="46mm"){
                customAmount+=15
            }
            if(value.iwatch_carrier==="GPS+"){
                customAmount+=20
            }
            if(iwatch_band==="No"){
                customAmount-=40
            }
            if(iwatch_band==="Solo loop"){
                customAmount=customAmount

            }
            if(iwatch_band==="Sport Band"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Brainded Solo Loop"){
                customAmount+=15
            }
            if(iwatch_band==="Link Bracelet"){
                customAmount+=20
            }
            if(iwatch_band==="Magnetic Link"){
                customAmount+=15
            }
            if(iwatch_band==="Melanese Loop"){
                customAmount+=15
            }
            
            if(iwatch_box==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_box==="No%"){
                customAmount-=10
            }
            if(iwatch_powercord==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_powercord==="No%"){
                customAmount-=40
            } if(value.iwatch_functional==="Yes"){
                customAmount=customAmount
            }
            if(value.iwatch_functional==="No"){
                customAmount-=customAmount
            }
            
        }
        if(iWatchData.iwatch_condition==="Defective"){
                
            if(value.iwatch_edition_casing==="Titanium Case"){
                customAmount+=180
            }
            if(value.iwatch_size==="46mm"){
                customAmount+=15
            }
            if(value.iwatch_carrier==="GPS+"){
                customAmount+=20
            }
            if(iwatch_band==="No"){
                customAmount-=40
            }
            if(iwatch_band==="Solo loop"){
                customAmount=customAmount

            }
            if(iwatch_band==="Sport Band"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Brainded Solo Loop"){
                customAmount+=15
            }
            if(iwatch_band==="Link Bracelet"){
                customAmount+=20
            }
            if(iwatch_band==="Magnetic Link"){
                customAmount+=15
            }
            if(iwatch_band==="Melanese Loop"){
                customAmount+=15
            }
            
            if(iwatch_box==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_box==="No%"){
                customAmount-=10
            }
            if(iwatch_powercord==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_powercord==="No%"){
                customAmount-=40
            } if(value.iwatch_functional==="Yes"){
                customAmount=customAmount
            }
            if(value.iwatch_functional==="No"){
                customAmount-=customAmount
            }
        }

            if(iWatchData.iwatch_condition==="Broken"){
                    customAmount-=customAmount
                
            }
        }
else if(selectedDevice[0].label==="Apple Watch Ultra 2"){
            iWatchData.iwatch_carrier=  ""
            iWatchData.iwatch_edition_casing=""
            iWatchData.iwatch_size=  ""
            iWatchData.iwatch_band= ""
            iWatchData.iwatch_functional= ""
            iWatchData.iwatch_box= ""
            iWatchData.iwatch_powercord= ""
            
            
            if(iWatchData.iwatch_condition === "Brand New"){
                customAmount=customAmount
            }
            if(iWatchData.iwatch_condition==="Like New")
                {
                
                if(iwatch_band==="No"){
                    customAmount-=35
                }
                if(iwatch_band==="Alpine loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Ocean Band"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Trail loop"){
                    customAmount=customAmount
                }
                if(iwatch_box==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_box==="No%"){
                    customAmount-=5
                }
                if(iwatch_powercord==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_powercord==="No%"){
                    customAmount-=40
                }  if(value.iwatch_functional==="Yes"){
                    customAmount=customAmount
                }
                if(value.iwatch_functional==="No"){
                    customAmount-=customAmount
                }
                
            }
            if(iWatchData.iwatch_condition==="Good") {
                
                if(iwatch_band==="No"){
                    customAmount-=35
                }
                if(iwatch_band==="Alpine loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Ocean Band"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Trail loop"){
                    customAmount=customAmount
                }
                if(iwatch_box==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_box==="No%"){
                    customAmount-=5
                }
                if(iwatch_powercord==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_powercord==="No%"){
                    customAmount-=40
                } if(value.iwatch_functional==="Yes"){
                    customAmount=customAmount
                }
                if(value.iwatch_functional==="No"){
                    customAmount-=customAmount
                }
                
            }
        if(iWatchData.iwatch_condition==="Fair") {
                
            if(iwatch_band==="No"){
                customAmount-=35
            }
            if(iwatch_band==="Alpine loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Ocean Band"){
                customAmount=customAmount
            }
            if(iwatch_band==="Trail loop"){
                customAmount=customAmount
            }
            if(iwatch_box==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_box==="No%"){
                customAmount-=5
            }
            if(iwatch_powercord==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_powercord==="No%"){
                customAmount-=40
            }  if(value.iwatch_functional==="Yes"){
                customAmount=customAmount
            }
            if(value.iwatch_functional==="No"){
                customAmount-=customAmount
            }
            
        }
        if(iWatchData.iwatch_condition==="Defective"){
                
            if(iwatch_band==="No"){
                customAmount-=35
            }
            if(iwatch_band==="Alpine loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Ocean Band"){
                customAmount=customAmount
            }
            if(iwatch_band==="Trail loop"){
                customAmount=customAmount
            }
            if(iwatch_box==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_box==="No%"){
                customAmount-=5
            }
            if(iwatch_powercord==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_powercord==="No%"){
                customAmount-=40
            }  if(value.iwatch_functional==="Yes"){
                customAmount=customAmount
            }
            if(value.iwatch_functional==="No"){
                customAmount-=customAmount
            }
        }

            if(iWatchData.iwatch_condition==="Broken"){
                    customAmount-=customAmount
                
            }
        }
else if(selectedDevice[0].label==="Apple Watch (Series 9)"){
            iWatchData.iwatch_carrier=  "GPS"
            iWatchData.iwatch_edition_casing="Aluminium Case"
            iWatchData.iwatch_size=  "41mm"
            iWatchData.iwatch_band= ""
            iWatchData.iwatch_functional= ""
            iWatchData.iwatch_box= ""
            iWatchData.iwatch_powercord= ""
            
            
            if(iWatchData.iwatch_condition === "Brand New"){
                customAmount=customAmount
            
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=40
                }
                if(value.iwatch_size==="45mm"){
                    customAmount+=15
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=20
                }
                
            }
            if(iWatchData.iwatch_condition==="Like New")
                {
               
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=40
                }
                if(value.iwatch_size==="45mm"){
                    customAmount+=15
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=20
                }
                if(iwatch_band==="No"){
                    customAmount-=15
                }
                if(iwatch_band==="Solo loop"){
                    customAmount=customAmount

                }
                if(iwatch_band==="Sport Band"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Brainded Solo Loop"){
                    customAmount+=15
                }
                if(iwatch_band==="Link Bracelet"){
                    customAmount+=20
                }
                if(iwatch_band==="Magnetic Link"){
                    customAmount+=15
                }
                if(iwatch_band==="Melanese Loop"){
                    customAmount+=15
                }
                if(iwatch_band==="Modern Buckle"){
                    customAmount+=20
                }
                if(iwatch_box==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_box==="No%"){
                    customAmount-=10
                }
                if(iwatch_powercord==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_powercord==="No%"){
                    customAmount-=40
                } if(value.iwatch_functional==="Yes"){
                    customAmount=customAmount
                }
                if(value.iwatch_functional==="No"){
                    customAmount-=customAmount
                }
                
            }
            if(iWatchData.iwatch_condition==="Good"){
                
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=40
                }
                if(value.iwatch_size==="45mm"){
                    customAmount+=15
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=20
                }
                if(iwatch_band==="No"){
                    customAmount-=15
                }
                if(iwatch_band==="Solo loop"){
                    customAmount=customAmount

                }
                if(iwatch_band==="Sport Band"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Brainded Solo Loop"){
                    customAmount+=15
                }
                if(iwatch_band==="Link Bracelet"){
                    customAmount+=20
                }
                if(iwatch_band==="Magnetic Link"){
                    customAmount+=15
                }
                if(iwatch_band==="Melanese Loop"){
                    customAmount+=15
                }
                if(iwatch_band==="Modern Buckle"){
                    customAmount+=20
                }
                if(iwatch_box==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_box==="No%"){
                    customAmount-=10
                }
                if(iwatch_powercord==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_powercord==="No%"){
                    customAmount-=15
                } if(value.iwatch_functional==="Yes"){
                    customAmount=customAmount
                }
                if(value.iwatch_functional==="No"){
                    customAmount-=customAmount
                }
                
            }
        if(iWatchData.iwatch_condition==="Fair"){
            
            if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                customAmount+=40
            }
            if(value.iwatch_size==="45mm"){
                customAmount+=15
            }
            if(value.iwatch_carrier==="GPS+"){
                customAmount+=20
            }
            if(iwatch_band==="No"){
                customAmount-=15
            }
            if(iwatch_band==="Solo loop"){
                customAmount=customAmount

            }
            if(iwatch_band==="Sport Band"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Brainded Solo Loop"){
                customAmount+=15
            }
            if(iwatch_band==="Link Bracelet"){
                customAmount+=20
            }
            if(iwatch_band==="Magnetic Link"){
                customAmount+=15
            }
            if(iwatch_band==="Melanese Loop"){
                customAmount+=15
            }
            if(iwatch_band==="Modern Buckle"){
                customAmount+=20
            }
            if(iwatch_box==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_box==="No%"){
                customAmount-=10
            }
            if(iwatch_powercord==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_powercord==="No%"){
                customAmount-=15
            } if(value.iwatch_functional==="Yes"){
                customAmount=customAmount
            }
            if(value.iwatch_functional==="No"){
                customAmount-=customAmount
            }
            
        }
        if(iWatchData.iwatch_condition==="Defective"){
                
            if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                customAmount+=40
            }
            if(value.iwatch_size==="45mm"){
                customAmount+=15
            }
            if(value.iwatch_carrier==="GPS+"){
                customAmount+=20
            }
            if(iwatch_band==="No"){
                customAmount-=15
            }
            if(iwatch_band==="Solo loop"){
                customAmount=customAmount

            }
            if(iwatch_band==="Sport Band"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Brainded Solo Loop"){
                customAmount+=15
            }
            if(iwatch_band==="Link Bracelet"){
                customAmount+=20
            }
            if(iwatch_band==="Magnetic Link"){
                customAmount+=15
            }
            if(iwatch_band==="Melanese Loop"){
                customAmount+=15
            }
            if(iwatch_band==="Modern Buckle"){
                customAmount+=20
            }
            if(iwatch_box==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_box==="No%"){
                customAmount-=10
            }
            if(iwatch_powercord==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_powercord==="No%"){
                customAmount-=15
            } if(value.iwatch_functional==="Yes"){
                customAmount=customAmount
            }
            if(value.iwatch_functional==="No"){
                customAmount-=customAmount
            }
        }

            if(iWatchData.iwatch_condition==="Broken"){
                    customAmount-=customAmount
                
            }
        }
else if(selectedDevice[0].label==="Apple Watch (Series 8)"){
            iWatchData.iwatch_carrier=  "GPS"
            iWatchData.iwatch_edition_casing="Aluminium Case"
            iWatchData.iwatch_size=  "41mm"
            iWatchData.iwatch_band= ""
            iWatchData.iwatch_functional= ""
            iWatchData.iwatch_box= ""
            iWatchData.iwatch_powercord= ""
            
            
            if(iWatchData.iwatch_condition === "Brand New"){
                customAmount=customAmount
            
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=10
                }
                if(value.iwatch_size==="45mm"){
                    customAmount+=10
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=10
                }
                
            }
            if(iWatchData.iwatch_condition==="Like New"){
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=10
                }
                if(value.iwatch_size==="45mm"){
                    customAmount+=10
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=10
                }
                
                if(iwatch_band==="No"){
                    customAmount-=20
                }
                if(iwatch_band==="Solo loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport Band"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Brainded Solo Loop"){
                    customAmount+=10
                }
                if(iwatch_band==="Link Bracelet"){
                    customAmount+=10
                }
                if(iwatch_band==="Magnetic Link"){
                    customAmount+=10
                }
                if(iwatch_band==="Melanese Loop"){
                    customAmount+=10
                }
                if(iwatch_band==="Modern Buckle"){
                    customAmount+=10
                }
                if(iwatch_box==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_box==="No%"){
                    customAmount-=5
                }
                if(iwatch_powercord==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_powercord==="No%"){
                    customAmount-=30
                } if(value.iwatch_functional==="Yes"){
                    customAmount=customAmount
                }
                if(value.iwatch_functional==="No"){
                    customAmount-=customAmount
                }
                
            }
            if(iWatchData.iwatch_condition==="Good"){
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=10
                }
                if(value.iwatch_size==="45mm"){
                    customAmount+=10
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=10
                }
                
                if(iwatch_band==="No"){
                    customAmount-=20
                }
                if(iwatch_band==="Solo loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport Band"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Brainded Solo Loop"){
                    customAmount+=10
                }
                if(iwatch_band==="Link Bracelet"){
                    customAmount+=10
                }
                if(iwatch_band==="Magnetic Link"){
                    customAmount+=10
                }
                if(iwatch_band==="Melanese Loop"){
                    customAmount+=10
                }
                if(iwatch_band==="Modern Buckle"){
                    customAmount+=10
                }
                if(iwatch_box==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_box==="No%"){
                    customAmount-=5
                }
                if(iwatch_powercord==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_powercord==="No%"){
                    customAmount-=30
                } if(value.iwatch_functional==="Yes"){
                    customAmount=customAmount
                }
                if(value.iwatch_functional==="No"){
                    customAmount-=customAmount
                }
                
            }
        if(iWatchData.iwatch_condition==="Fair"){
            if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                customAmount+=10
            }
            if(value.iwatch_size==="45mm"){
                customAmount+=10
            }
            if(value.iwatch_carrier==="GPS+"){
                customAmount+=10
            }
            
            if(iwatch_band==="No"){
                customAmount-=20
            }
            if(iwatch_band==="Solo loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport Band"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Brainded Solo Loop"){
                customAmount+=10
            }
            if(iwatch_band==="Link Bracelet"){
                customAmount+=10
            }
            if(iwatch_band==="Magnetic Link"){
                customAmount+=10
            }
            if(iwatch_band==="Melanese Loop"){
                customAmount+=10
            }
            if(iwatch_band==="Modern Buckle"){
                customAmount+=10
            }
            if(iwatch_box==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_box==="No%"){
                customAmount-=5
            }
            if(iwatch_powercord==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_powercord==="No%"){
                customAmount-=30
            }  if(value.iwatch_functional==="Yes"){
                customAmount=customAmount
            }
            if(value.iwatch_functional==="No"){
                customAmount-=customAmount
            }
            
        }
        if(iWatchData.iwatch_condition==="Defective"){
                
           
            {
                customAmount+=10
            }
            
            if(iwatch_band==="No"){
                customAmount-=20
            }
            if(iwatch_band==="Solo loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport Band"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Brainded Solo Loop"){
                customAmount+=10
            }
            if(iwatch_band==="Link Bracelet"){
                customAmount+=10
            }
            if(iwatch_band==="Magnetic Link"){
                customAmount+=10
            }
            if(iwatch_band==="Melanese Loop"){
                customAmount+=10
            }
            if(iwatch_band==="Modern Buckle"){
                customAmount+=10
            }
            if(iwatch_box==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_box==="No%"){
                customAmount-=5
            }
            if(iwatch_powercord==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_powercord==="No%"){
                customAmount-=30
            }  if(value.iwatch_functional==="Yes"){
                customAmount=customAmount
            }
            if(value.iwatch_functional==="No"){
                customAmount-=customAmount
            }
            
        }

            if(iWatchData.iwatch_condition==="Broken"){
                    customAmount-=customAmount
                
            }
        }
else if(selectedDevice[0].label==="Apple Watch (SE) 2nd Gen."){
            iWatchData.iwatch_carrier=  "GPS"
            iWatchData.iwatch_edition_casing="Aluminium Case"
            iWatchData.iwatch_size=  "40mm"
            iWatchData.iwatch_band= ""
            iWatchData.iwatch_functional= ""
            iWatchData.iwatch_box= ""
            iWatchData.iwatch_powercord= ""
            
            
            if(iWatchData.iwatch_condition === "Brand New"){
                customAmount=customAmount
            
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=10
                }
                if(value.iwatch_edition_casing==="Ceramic Case"){
                    customAmount+=10
                }
                if(value.iwatch_size==="44mm"){
                    customAmount+=15
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=20
                }
                
            }
            if(iWatchData.iwatch_condition==="Like New"){
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=10
                }
                if(value.iwatch_edition_casing==="Ceramic Case"){
                    customAmount+=10
                }
                if(value.iwatch_size==="44mm"){
                    customAmount+=15
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=20
                }
                if(iwatch_band==="No"){
                    customAmount-=25
                }
                if(iwatch_band==="Solo loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport Band"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Brainded Solo Loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Link Bracelet"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Magnetic Link"){
                    customAmount+=10
                }
                if(iwatch_band==="Melanese Loop"){
                    customAmount+=20
                }
                if(iwatch_band==="Modern Buckle"){
                    customAmount+=30
                }
                if(iwatch_box==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_box==="No%"){
                    customAmount-=5
                }
                if(iwatch_powercord==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_powercord==="No%"){
                    customAmount-=25
                } if(value.iwatch_functional==="Yes"){
                    customAmount=customAmount
                }
                if(value.iwatch_functional==="No"){
                    customAmount-=customAmount
                }
                
            }
            if(iWatchData.iwatch_condition==="Good"){
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=10
                }
                if(value.iwatch_edition_casing==="Ceramic Case"){
                    customAmount+=10
                }
                if(value.iwatch_size==="44mm"){
                    customAmount+=15
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=20
                }
                if(iwatch_band==="No"){
                    customAmount-=25
                }
                if(iwatch_band==="Solo loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport Band"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Brainded Solo Loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Link Bracelet"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Magnetic Link"){
                    customAmount+=10
                }
                if(iwatch_band==="Melanese Loop"){
                    customAmount+=20
                }
                if(iwatch_band==="Modern Buckle"){
                    customAmount+=30
                }
                if(iwatch_box==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_box==="No%"){
                    customAmount-=5
                }
                if(iwatch_powercord==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_powercord==="No%"){
                    customAmount-=25
                } if(value.iwatch_functional==="Yes"){
                    customAmount=customAmount
                }
                if(value.iwatch_functional==="No"){
                    customAmount-=customAmount
                }
                
            }
        if(iWatchData.iwatch_condition==="Fair"){
            if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                customAmount+=10
            }
            if(value.iwatch_edition_casing==="Ceramic Case"){
                customAmount+=10
            }
            if(value.iwatch_size==="44mm"){
                customAmount+=15
            }
            if(value.iwatch_carrier==="GPS+"){
                customAmount+=20
            }
            
            if(iwatch_band==="No"){
                customAmount-=25
            }
            if(iwatch_band==="Solo loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport Band"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Brainded Solo Loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Link Bracelet"){
                customAmount=customAmount
            }
            if(iwatch_band==="Magnetic Link"){
                customAmount+=10
            }
            if(iwatch_band==="Melanese Loop"){
                customAmount+=20
            }
            if(iwatch_band==="Modern Buckle"){
                customAmount+=30
            }
            if(iwatch_box==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_box==="No%"){
                customAmount-=5
            }
            if(iwatch_powercord==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_powercord==="No%"){
                customAmount-=25
            } if(value.iwatch_functional==="Yes"){
                customAmount=customAmount
            }
            if(value.iwatch_functional==="No"){
                customAmount-=customAmount
            }
            
        }
        if(iWatchData.iwatch_condition==="Defective"){
                
            if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                customAmount+=10
            }
            if(value.iwatch_edition_casing==="Ceramic Case"){
                customAmount+=10
            }
            if(value.iwatch_size==="44mm"){
                customAmount+=15
            }
            if(value.iwatch_carrier==="GPS+"){
                customAmount+=20
            }
            
            if(iwatch_band==="No"){
                customAmount-=25
            }
            if(iwatch_band==="Solo loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport Band"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Brainded Solo Loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Link Bracelet"){
                customAmount=customAmount
            }
            if(iwatch_band==="Magnetic Link"){
                customAmount+=10
            }
            if(iwatch_band==="Melanese Loop"){
                customAmount+=20
            }
            if(iwatch_band==="Modern Buckle"){
                customAmount+=30
            }
            if(iwatch_box==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_box==="No%"){
                customAmount-=5
            }
            if(iwatch_powercord==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_powercord==="No%"){
                customAmount-=25
            } if(value.iwatch_functional==="Yes"){
                customAmount=customAmount
            }
            if(value.iwatch_functional==="No"){
                customAmount-=customAmount
            }
        }

            if(iWatchData.iwatch_condition==="Broken"){
                    customAmount-=customAmount
                
            }
        }
else if(selectedDevice[0].label==="Apple Watch (SE) 1st Gen."){
            iWatchData.iwatch_carrier=  "GPS"
            iWatchData.iwatch_edition_casing="Aluminium Case"
            iWatchData.iwatch_size=  "40mm"
            iWatchData.iwatch_band= ""
            iWatchData.iwatch_functional= ""
            iWatchData.iwatch_box= ""
            iWatchData.iwatch_powercord= ""
            
            
            if(iWatchData.iwatch_condition === "Brand New"){
                customAmount=customAmount
            
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=10
                }
               
                if(value.iwatch_size==="44mm"){
                    customAmount+=10
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=5
                }
                
            }
            if(iWatchData.iwatch_condition==="Like New"){
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=10
                }
               
                if(value.iwatch_size==="44mm"){
                    customAmount+=10
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=5
                }
                if(iwatch_band==="No"){
                    customAmount-=10
                }
                if(iwatch_band==="Solo loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport Band"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Brainded Solo Loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Link Bracelet"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Magnetic Link"){
                    customAmount+=5
                }
                if(iwatch_band==="Melanese Loop"){
                    customAmount+=5
                }
                if(iwatch_band==="Modern Buckle"){
                    customAmount+=5
                }
                if(iwatch_box==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_box==="No%"){
                    customAmount-=5
                }
                if(iwatch_powercord==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_powercord==="No%"){
                    customAmount-=10
                } if(value.iwatch_functional==="Yes"){
                    customAmount=customAmount
                }
                if(value.iwatch_functional==="No"){
                    customAmount-=customAmount
                }
                
            }
            if(iWatchData.iwatch_condition==="Good"){
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=10
                }
               
                if(value.iwatch_size==="44mm"){
                    customAmount+=10
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=5
                }
                if(iwatch_band==="No"){
                    customAmount-=10
                }
                if(iwatch_band==="Solo loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport Band"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Brainded Solo Loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Link Bracelet"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Magnetic Link"){
                    customAmount+=5
                }
                if(iwatch_band==="Melanese Loop"){
                    customAmount+=5
                }
                if(iwatch_band==="Modern Buckle"){
                    customAmount+=5
                }
                if(iwatch_box==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_box==="No%"){
                    customAmount-=5
                }
                if(iwatch_powercord==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_powercord==="No%"){
                    customAmount-=10
                } if(value.iwatch_functional==="Yes"){
                    customAmount=customAmount
                }
                if(value.iwatch_functional==="No"){
                    customAmount-=customAmount
                }
            }
        if(iWatchData.iwatch_condition==="Fair"){
            if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                customAmount+=10
            }
           
            if(value.iwatch_size==="44mm"){
                customAmount+=10
            }
            if(value.iwatch_carrier==="GPS+"){
                customAmount+=5
            }
            if(iwatch_band==="No"){
                customAmount-=10
            }
            if(iwatch_band==="Solo loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport Band"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Brainded Solo Loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Link Bracelet"){
                customAmount=customAmount
            }
            if(iwatch_band==="Magnetic Link"){
                customAmount+=5
            }
            if(iwatch_band==="Melanese Loop"){
                customAmount+=5
            }
            if(iwatch_band==="Modern Buckle"){
                customAmount+=5
            }
            if(iwatch_box==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_box==="No%"){
                customAmount-=5
            }
            if(iwatch_powercord==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_powercord==="No%"){
                customAmount-=5
            } if(value.iwatch_functional==="Yes"){
                customAmount=customAmount
            }
            if(value.iwatch_functional==="No"){
                customAmount-=customAmount
            }
            
        }
        if(iWatchData.iwatch_condition==="Defective"){
                
            if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                customAmount+=10
            }
           
            if(value.iwatch_size==="44mm"){
                customAmount+=10
            }
            if(value.iwatch_carrier==="GPS+"){
                customAmount+=5
            }
            if(iwatch_band==="No"){
                customAmount-=10
            }
            if(iwatch_band==="Solo loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport Band"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Brainded Solo Loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Link Bracelet"){
                customAmount=customAmount
            }
            if(iwatch_band==="Magnetic Link"){
                customAmount+=5
            }
            if(iwatch_band==="Melanese Loop"){
                customAmount+=5
            }
            if(iwatch_band==="Modern Buckle"){
                customAmount+=5
            }
            if(iwatch_box==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_box==="No%"){
                customAmount-=5
            }
            if(iwatch_powercord==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_powercord==="No%"){
                customAmount-=5
            } if(value.iwatch_functional==="Yes"){
                customAmount=customAmount
            }
            if(value.iwatch_functional==="No"){
                customAmount-=customAmount
            }
        }

            if(iWatchData.iwatch_condition==="Broken"){
                    customAmount-=customAmount
                
            }
        }
else if(selectedDevice[0].label==="Apple Watch (Series 7)"){
            iWatchData.iwatch_carrier=  "GPS"
            iWatchData.iwatch_edition_casing="Aluminium Case"
            iWatchData.iwatch_size=  "41mm"
            iWatchData.iwatch_band= ""
            iWatchData.iwatch_functional= ""
            iWatchData.iwatch_box= ""
            iWatchData.iwatch_powercord= ""
            
            
            if(iWatchData.iwatch_condition === "Brand New"){
                customAmount=customAmount
            
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=20
                }
                if(value.iwatch_edition_casing==="Titanium Case"){
                    customAmount+=10
                }
                if(value.iwatch_size==="45mm"){
                    customAmount+=10
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=10
                }
                
                
            }
            if(iWatchData.iwatch_condition==="Like New"){
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=20
                }
                if(value.iwatch_edition_casing==="Titanium Case"){
                    customAmount+=10
                }
                if(value.iwatch_size==="45mm"){
                    customAmount+=10
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=10
                }
                
                if(iwatch_band==="No"){
                    customAmount-=10
                }
                if(iwatch_band==="Solo loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport Band"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Brainded Solo Loop"){
                    customAmount+=5
                }
                if(iwatch_band==="Link Bracelet"){
                    customAmount+=5
                }
                if(iwatch_band==="Magnetic Link"){
                    customAmount+=5
                }
                if(iwatch_band==="Melanese Loop"){
                    customAmount+=5
                }
                if(iwatch_band==="Modern Buckle"){
                    customAmount+=5
                }
                if(iwatch_box==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_box==="No%"){
                    customAmount-=5
                }
                if(iwatch_powercord==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_powercord==="No%"){
                    customAmount-=10
                } if(value.iwatch_functional==="Yes"){
                    customAmount=customAmount
                }
                if(value.iwatch_functional==="No"){
                    customAmount-=customAmount
                }
                
            }
            if(iWatchData.iwatch_condition==="Good"){
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=20
                }
                if(value.iwatch_edition_casing==="Titanium Case"){
                    customAmount+=10
                }
                if(value.iwatch_size==="45mm"){
                    customAmount+=10
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=10
                }
                
                if(iwatch_band==="No"){
                    customAmount-=10
                }
                if(iwatch_band==="Solo loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport Band"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Brainded Solo Loop"){
                    customAmount+=5
                }
                if(iwatch_band==="Link Bracelet"){
                    customAmount+=5
                }
                if(iwatch_band==="Magnetic Link"){
                    customAmount+=5
                }
                if(iwatch_band==="Melanese Loop"){
                    customAmount+=5
                }
                if(iwatch_band==="Modern Buckle"){
                    customAmount+=5
                }
                if(iwatch_box==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_box==="No%"){
                    customAmount-=5
                }
                if(iwatch_powercord==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_powercord==="No%"){
                    customAmount-=10
                }  if(value.iwatch_functional==="Yes"){
                    customAmount=customAmount
                }
                if(value.iwatch_functional==="No"){
                    customAmount-=customAmount
                }
                
        }
        if(iWatchData.iwatch_condition==="Fair"){
            if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                customAmount+=20
            }
            if(value.iwatch_edition_casing==="Titanium Case"){
                customAmount+=10
            }
            if(value.iwatch_size==="45mm"){
                customAmount+=10
            }
            if(value.iwatch_carrier==="GPS+"){
                customAmount+=10
            }
            
            if(iwatch_band==="No"){
                customAmount-=10
            }
            if(iwatch_band==="Solo loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport Band"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Brainded Solo Loop"){
                customAmount+=5
            }
            if(iwatch_band==="Link Bracelet"){
                customAmount+=5
            }
            if(iwatch_band==="Magnetic Link"){
                customAmount+=5
            }
            if(iwatch_band==="Melanese Loop"){
                customAmount+=5
            }
            if(iwatch_band==="Modern Buckle"){
                customAmount+=5
            }
            if(iwatch_box==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_box==="No%"){
                customAmount-=5
            }
            if(iwatch_powercord==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_powercord==="No%"){
                customAmount-=10
            } if(value.iwatch_functional==="Yes"){
                customAmount=customAmount
            }
            if(value.iwatch_functional==="No"){
                customAmount-=customAmount
            }
        }
        if(iWatchData.iwatch_condition==="Defective"){
                
            if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                customAmount+=20
            }
            if(value.iwatch_edition_casing==="Titanium Case"){
                customAmount+=10
            }
            if(value.iwatch_size==="45mm"){
                customAmount+=10
            }
            if(value.iwatch_carrier==="GPS+"){
                customAmount+=10
            }
            
            if(iwatch_band==="No"){
                customAmount-=10
            }
            if(iwatch_band==="Solo loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport Band"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Brainded Solo Loop"){
                customAmount+=5
            }
            if(iwatch_band==="Link Bracelet"){
                customAmount+=5
            }
            if(iwatch_band==="Magnetic Link"){
                customAmount+=5
            }
            if(iwatch_band==="Melanese Loop"){
                customAmount+=5
            }
            if(iwatch_band==="Modern Buckle"){
                customAmount+=5
            }
            if(iwatch_box==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_box==="No%"){
                customAmount-=5
            }
            if(iwatch_powercord==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_powercord==="No%"){
                customAmount-=10
            } if(value.iwatch_functional==="Yes"){
                customAmount=customAmount
            }
            if(value.iwatch_functional==="No"){
                customAmount-=customAmount
            }
        }

            if(iWatchData.iwatch_condition==="Broken"){
                    customAmount-=customAmount
                
            }
        }
else if(selectedDevice[0].label==="Apple Watch (Series 6)"){
            iWatchData.iwatch_carrier=  "GPS"
            iWatchData.iwatch_edition_casing="Aluminium Case"
            iWatchData.iwatch_size=  "40mm"
            iWatchData.iwatch_band= ""
            iWatchData.iwatch_functional= ""
            iWatchData.iwatch_box= ""
            iWatchData.iwatch_powercord= ""
            
            
            if(iWatchData.iwatch_condition === "Brand New"){
                customAmount=customAmount
            
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=30
                }
                if(value.iwatch_edition_casing==="Titanium Case"){
                    customAmount+=20
                }
                if(value.iwatch_size==="44mm"){
                    customAmount+=10
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=10
                }
                
            }
            if(iWatchData.iwatch_condition==="Like New"){
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=30
                }
                if(value.iwatch_edition_casing==="Titanium Case"){
                    customAmount+=20
                }
                if(value.iwatch_size==="44mm"){
                    customAmount+=10
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=10
                }
                if(iwatch_band==="No"){
                    customAmount-=20
                }
                if(iwatch_band==="Solo loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport Band"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Brainded Solo Loop"){
                    customAmount+=15
                }
                if(iwatch_band==="Link Bracelet"){
                    customAmount+=15
                }
                if(iwatch_band==="Magnetic Link"){
                    customAmount+=15
                }
                if(iwatch_band==="Melanese Loop"){
                    customAmount+=15
                }
                if(iwatch_band==="Modern Buckle"){
                    customAmount+=20
                }
                if(iwatch_box==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_box==="No%"){
                    customAmount-=5
                }
                if(iwatch_powercord==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_powercord==="No%"){
                    customAmount-=10
                } if(value.iwatch_functional==="Yes"){
                    customAmount=customAmount
                }
                if(value.iwatch_functional==="No"){
                    customAmount-=customAmount
                }
                
            }
            if(iWatchData.iwatch_condition==="Good"){
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=30
                }
                if(value.iwatch_edition_casing==="Titanium Case"){
                    customAmount+=20
                }
                if(value.iwatch_size==="44mm"){
                    customAmount+=10
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=10
                }
                
                if(iwatch_band==="No"){
                    customAmount-=20
                }
                if(iwatch_band==="Solo loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport Band"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Brainded Solo Loop"){
                    customAmount+=15
                }
                if(iwatch_band==="Link Bracelet"){
                    customAmount+=15
                }
                if(iwatch_band==="Magnetic Link"){
                    customAmount+=15
                }
                if(iwatch_band==="Melanese Loop"){
                    customAmount+=15
                }
                if(iwatch_band==="Modern Buckle"){
                    customAmount+=20
                }
                if(iwatch_box==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_box==="No%"){
                    customAmount-=5
                }
                if(iwatch_powercord==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_powercord==="No%"){
                    customAmount-=10
                } if(value.iwatch_functional==="Yes"){
                    customAmount=customAmount
                }
                if(value.iwatch_functional==="No"){
                    customAmount-=customAmount
                }
                
            }
        if(iWatchData.iwatch_condition==="Fair"){
            if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                customAmount+=30
            }
            if(value.iwatch_edition_casing==="Titanium Case"){
                customAmount+=20
            }
            if(value.iwatch_size==="44mm"){
                customAmount+=10
            }
            if(value.iwatch_carrier==="GPS+"){
                customAmount+=10
            }
            
            if(iwatch_band==="No"){
                customAmount-=20
            }
            if(iwatch_band==="Solo loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport Band"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Brainded Solo Loop"){
                customAmount+=15
            }
            if(iwatch_band==="Link Bracelet"){
                customAmount+=15
            }
            if(iwatch_band==="Magnetic Link"){
                customAmount+=15
            }
            if(iwatch_band==="Melanese Loop"){
                customAmount+=15
            }
            if(iwatch_band==="Modern Buckle"){
                customAmount+=20
            }
            if(iwatch_box==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_box==="No%"){
                customAmount-=5
            }
            if(iwatch_powercord==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_powercord==="No%"){
                customAmount-=10
            } if(value.iwatch_functional==="Yes"){
                customAmount=customAmount
            }
            if(value.iwatch_functional==="No"){
                customAmount-=customAmount
            }
            
        }
        if(iWatchData.iwatch_condition==="Defective"){
                
            if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                customAmount+=30
            }
            if(value.iwatch_edition_casing==="Titanium Case"){
                customAmount+=20
            }
            if(value.iwatch_size==="44mm"){
                customAmount+=10
            }
            if(value.iwatch_carrier==="GPS+"){
                customAmount+=10
            }
            
            if(iwatch_band==="No"){
                customAmount-=20
            }
            if(iwatch_band==="Solo loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport Band"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Brainded Solo Loop"){
                customAmount+=15
            }
            if(iwatch_band==="Link Bracelet"){
                customAmount+=15
            }
            if(iwatch_band==="Magnetic Link"){
                customAmount+=15
            }
            if(iwatch_band==="Melanese Loop"){
                customAmount+=15
            }
            if(iwatch_band==="Modern Buckle"){
                customAmount+=20
            }
            if(iwatch_box==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_box==="No%"){
                customAmount-=5
            }
            if(iwatch_powercord==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_powercord==="No%"){
                customAmount-=10
            } if(value.iwatch_functional==="Yes"){
                customAmount=customAmount
            }
            if(value.iwatch_functional==="No"){
                customAmount-=customAmount
            }
        }

            if(iWatchData.iwatch_condition==="Broken"){
                    customAmount-=customAmount
                
            }
        }
else if(selectedDevice[0].label==="Apple Watch (Series 5)"){
            iWatchData.iwatch_carrier=  "GPS"
            iWatchData.iwatch_edition_casing="Aluminium Case"
            iWatchData.iwatch_size=  "40mm"
            iWatchData.iwatch_band= ""
            iWatchData.iwatch_functional= ""
            iWatchData.iwatch_box= ""
            iWatchData.iwatch_powercord= ""
            
            
            if(iWatchData.iwatch_condition === "Brand New"){
                customAmount=customAmount
            
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=20
                }
                if(value.iwatch_edition_casing==="Titanium Case"){
                    customAmount+=20
                }
                if(value.iwatch_edition_casing==="Ceramic Case"){
                    customAmount+=20
                }
                if(value.iwatch_size==="44mm"){
                    customAmount+=15
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=5
                }
                
            }
            if(iWatchData.iwatch_condition==="Like New"){
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=20
                }
                if(value.iwatch_edition_casing==="Titanium Case"){
                    customAmount+=20
                }
                if(value.iwatch_edition_casing==="Ceramic Case"){
                    customAmount+=20
                }
                if(value.iwatch_size==="44mm"){
                    customAmount+=15
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=5
                }
         
                if(iwatch_band==="No"){
                    customAmount-=20
                }
                if(iwatch_band==="Leather loop"){
                    customAmount+=15
                }
                if(iwatch_band==="Sport Band"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Link Bracelet"){
                    customAmount+=15
                }
                if(iwatch_band==="Magnetic Link"){
                    customAmount+=15
                }
                if(iwatch_band==="Melanese Loop"){
                    customAmount+=15
                }
                if(iwatch_band==="Modern Buckle"){
                    customAmount+=15
                }
                if(iwatch_box==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_box==="No%"){
                    customAmount-=5
                }
                if(iwatch_powercord==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_powercord==="No%"){
                    customAmount-=10
                }  if(value.iwatch_functional==="Yes"){
                    customAmount=customAmount
                }
                if(value.iwatch_functional==="No"){
                    customAmount-=customAmount
                }
                
            }
            if(iWatchData.iwatch_condition==="Good"){
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=20
                }
                if(value.iwatch_edition_casing==="Titanium Case"){
                    customAmount+=20
                }
                if(value.iwatch_edition_casing==="Ceramic Case"){
                    customAmount+=20
                }
                if(value.iwatch_size==="44mm"){
                    customAmount+=15
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=5
                }
         
                if(iwatch_band==="No"){
                    customAmount-=20
                }
                if(iwatch_band==="Leather loop"){
                    customAmount+=15
                }
                if(iwatch_band==="Sport Band"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Link Bracelet"){
                    customAmount+=15
                }
                if(iwatch_band==="Magnetic Link"){
                    customAmount+=15
                }
                if(iwatch_band==="Melanese Loop"){
                    customAmount+=15
                }
                if(iwatch_band==="Modern Buckle"){
                    customAmount+=15
                }
                if(iwatch_box==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_box==="No%"){
                    customAmount-=5
                }
                if(iwatch_powercord==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_powercord==="No%"){
                    customAmount-=10
                }  if(value.iwatch_functional==="Yes"){
                    customAmount=customAmount
                }
                if(value.iwatch_functional==="No"){
                    customAmount-=customAmount
                }
                
            }
        if(iWatchData.iwatch_condition==="Fair"){
            if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                customAmount+=20
            }
            if(value.iwatch_edition_casing==="Titanium Case"){
                customAmount+=20
            }
            if(value.iwatch_edition_casing==="Ceramic Case"){
                customAmount+=20
            }
            if(value.iwatch_size==="44mm"){
                customAmount+=15
            }
            if(value.iwatch_carrier==="GPS+"){
                customAmount+=5
            }
            if(iwatch_band==="No"){
                customAmount-=20
            }
            if(iwatch_band==="Leather loop"){
                customAmount+=15
            }
            if(iwatch_band==="Sport Band"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Link Bracelet"){
                customAmount+=15
            }
            if(iwatch_band==="Magnetic Link"){
                customAmount+=15
            }
            if(iwatch_band==="Melanese Loop"){
                customAmount+=15
            }
            if(iwatch_band==="Modern Buckle"){
                customAmount+=15
            }
            if(iwatch_box==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_box==="No%"){
                customAmount-=5
            }
            if(iwatch_powercord==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_powercord==="No%"){
                customAmount-=10
            }  if(value.iwatch_functional==="Yes"){
                customAmount=customAmount
            }
            if(value.iwatch_functional==="No"){
                customAmount-=customAmount
            }
            
        }
        if(iWatchData.iwatch_condition==="Defective"){
                
            if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                customAmount+=20
            }
            if(value.iwatch_edition_casing==="Titanium Case"){
                customAmount+=20
            }
            if(value.iwatch_edition_casing==="Ceramic Case"){
                customAmount+=20
            }
            if(value.iwatch_size==="44mm"){
                customAmount+=15
            }
            if(value.iwatch_carrier==="GPS+"){
                customAmount+=5
            }
            if(iwatch_band==="No"){
                customAmount-=20
            }
            if(iwatch_band==="Leather loop"){
                customAmount+=15
            }
            if(iwatch_band==="Sport Band"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Link Bracelet"){
                customAmount+=15
            }
            if(iwatch_band==="Magnetic Link"){
                customAmount+=15
            }
            if(iwatch_band==="Melanese Loop"){
                customAmount+=15
            }
            if(iwatch_band==="Modern Buckle"){
                customAmount+=15
            }
            if(iwatch_box==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_box==="No%"){
                customAmount-=5
            }
            if(iwatch_powercord==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_powercord==="No%"){
                customAmount-=10
            }  if(value.iwatch_functional==="Yes"){
                customAmount=customAmount
            }
            if(value.iwatch_functional==="No"){
                customAmount-=customAmount
            }
        }

            if(iWatchData.iwatch_condition==="Broken"){
                    customAmount-=customAmount
                
            }
        }
else if(selectedDevice[0].label==="Apple Watch (Series 4)"){
            iWatchData.iwatch_carrier=  "GPS"
            iWatchData.iwatch_edition_casing="Aluminium Case"
            iWatchData.iwatch_size=  "40mm"
            iWatchData.iwatch_band= ""
            iWatchData.iwatch_functional= ""
            iWatchData.iwatch_box= ""
            iWatchData.iwatch_powercord= ""
            
            
            if(iWatchData.iwatch_condition === "Brand New"){
                customAmount=customAmount
            
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=10
                }
                
                if(value.iwatch_size==="44mm"){
                    customAmount+=5
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=5
                }
                
            }
            if(iWatchData.iwatch_condition==="Like New"){
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=10
                }
                
                if(value.iwatch_size==="44mm"){
                    customAmount+=5
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=5
                }
         
                if(iwatch_band==="No"){
                    customAmount-=20
                }
                if(iwatch_band==="Leather loop"){
                    customAmount+=15
                }
                if(iwatch_band==="Sport Band"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Link Bracelet"){
                    customAmount+=15
                }
                if(iwatch_band==="Magnetic Link"){
                    customAmount+=15
                }
                if(iwatch_band==="Melanese Loop"){
                    customAmount+=15
                }
                if(iwatch_band==="Modern Buckle"){
                    customAmount+=15
                }
                if(iwatch_box==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_box==="No%"){
                    customAmount-=5
                }
                if(iwatch_powercord==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_powercord==="No%"){
                    customAmount-=5
                } if(value.iwatch_functional==="Yes"){
                    customAmount=customAmount
                }
                if(value.iwatch_functional==="No"){
                    customAmount-=customAmount
                }
                
            }
            if(iWatchData.iwatch_condition==="Good"){
                if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                    customAmount+=10
                }
                
                if(value.iwatch_size==="44mm"){
                    customAmount+=5
                }
                if(value.iwatch_carrier==="GPS+"){
                    customAmount+=5
                }
                if(iwatch_band==="No"){
                    customAmount-=20
                }
                if(iwatch_band==="Leather loop"){
                    customAmount+=15
                }
                if(iwatch_band==="Sport Band"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Sport loop"){
                    customAmount=customAmount
                }
                if(iwatch_band==="Link Bracelet"){
                    customAmount+=15
                }
                if(iwatch_band==="Magnetic Link"){
                    customAmount+=15
                }
                if(iwatch_band==="Melanese Loop"){
                    customAmount+=15
                }
                if(iwatch_band==="Modern Buckle"){
                    customAmount+=15
                }
                if(iwatch_box==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_box==="No%"){
                    customAmount-=5
                }
                if(iwatch_powercord==="Yes"){
                    customAmount=customAmount
                }
                if(iwatch_powercord==="No%"){
                    customAmount-=5
                } if(value.iwatch_functional==="Yes"){
                    customAmount=customAmount
                }
                if(value.iwatch_functional==="No"){
                    customAmount-=customAmount
                }
                
            }
        if(iWatchData.iwatch_condition==="Fair"){
            if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                customAmount+=10
            }
            
            if(value.iwatch_size==="44mm"){
                customAmount+=5
            }
            if(value.iwatch_carrier==="GPS+"){
                customAmount+=5
            }
            if(iwatch_band==="No"){
                customAmount-=20
            }
            if(iwatch_band==="Leather loop"){
                customAmount+=15
            }
            if(iwatch_band==="Sport Band"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Link Bracelet"){
                customAmount+=15
            }
            if(iwatch_band==="Magnetic Link"){
                customAmount+=15
            }
            if(iwatch_band==="Melanese Loop"){
                customAmount+=15
            }
            if(iwatch_band==="Modern Buckle"){
                customAmount+=15
            }
            if(iwatch_box==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_box==="No%"){
                customAmount-=5
            }
            if(iwatch_powercord==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_powercord==="No%"){
                customAmount-=5
            } if(value.iwatch_functional==="Yes"){
                customAmount=customAmount
            }
            if(value.iwatch_functional==="No"){
                customAmount-=customAmount
            }
            
        }
        if(iWatchData.iwatch_condition==="Defective"){
                
            if(value.iwatch_edition_casing==="Stainless-Steel Case"){
                customAmount+=10
            }
            
            if(value.iwatch_size==="44mm"){
                customAmount+=5
            }
            if(value.iwatch_carrier==="GPS+"){
                customAmount+=5
            }
            if(iwatch_band==="No"){
                customAmount-=20
            }
            if(iwatch_band==="Leather loop"){
                customAmount+=15
            }
            if(iwatch_band==="Sport Band"){
                customAmount=customAmount
            }
            if(iwatch_band==="Sport loop"){
                customAmount=customAmount
            }
            if(iwatch_band==="Link Bracelet"){
                customAmount+=15
            }
            if(iwatch_band==="Magnetic Link"){
                customAmount+=15
            }
            if(iwatch_band==="Melanese Loop"){
                customAmount+=15
            }
            if(iwatch_band==="Modern Buckle"){
                customAmount+=15
            }
            if(iwatch_box==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_box==="No%"){
                customAmount-=5
            }
            if(iwatch_powercord==="Yes"){
                customAmount=customAmount
            }
            if(iwatch_powercord==="No%"){
                customAmount-=5
            } if(value.iwatch_functional==="Yes"){
                customAmount=customAmount
            }
            if(value.iwatch_functional==="No"){
                customAmount-=customAmount
            }
        }

            if(iWatchData.iwatch_condition==="Broken"){
                    customAmount-=customAmount
                
            }
        }


        iWatch(iWatchData).then(res => {
            if (!isEmpty(res.data && res.data.results)) {
                setOffers(res.data.results)
            }
            setIsLoader(false)
            if(value.iwatch_condition==="Brand New"){
                //console.log("condition is brand new")
            }
            if (!isEmpty(res.data && res.data.results)) {
                let offer = +res.data.results[0].offer
                offer = offer + customAmount;
                setOffers([{ ...res.data.results[0], offer }])
                if (offer <= 0) {
                    setIsBrokenOrNo(true)
                }
            }
        }).catch(err => {
            setIsLoader(false)
            //console.log(err);
        })
       
        
    }
    
    const addCart = (value) => {
        const data = {
            deviceType: "iWatch",
            deviceModel: value.iwatch_model,
            deviceCapacity: "",
            deviceCarrier: value.iwatch_carrier,
            deviceCondition: value.iwatch_condition,
            deviceYear: "",
            deviceProcessor: "",
            deviceOffer: parseInt(value.offer),
            deviceGeneration: "",
            deviceSize: value.iwatch_size,
            deviceEdition: value.iwatch_edition_casing,
            deviceBand: value.iwatch_band,
            deviceEngraving: "",
            deviceImages: imagePath,
            deviceId: uuid,
        }
        dispatch(addToCart(data))
        props.history.push("/cart");
    }

    
    return (
        <div className="p-2 vh-70">
            <div className={!isEmpty(selectedDevice) ? 'device-selected' : ''}>
                 { isEmpty(selectedDevice) && 
                      <span className="text-center"style={{fontSize:20}}>Select your iWatch Model</span>}
            {
                isEmpty(selectedDevice) &&
                <>
                    <div className="grid-container">
                  

                        {
                            !isEmpty(deviceList1) && deviceList1.map((item, index) => (
                               
                                 <div  className="grid-item"key={index}>
                                    <div className="bg-white">
                                    <img className=" cursor-pointer w-25 h-50" src={item.devicePhoto} onClick={() => {selectDevice(item);window.scrollTo(0, 0);}} />
                                    </div>
                                    <div className="text-center mt-1">
                                    <span style={{fontSize:15, fontFamily:''}}  onClick={() => {selectDevice(item);window.scrollTo(0, 0);}}variant="warning">{item.label}</span>
                                    </div>
                                </div>
                              
                               
                            ))
                        }
                    </div>
                    </>
               
            }
             </div>

            <Formik
                initialValues={{
                    iwatch_model: '',
                    iwatch_carrier: '',
                    iwatch_edition_casing: '',
                    iwatch_size: '',
                    iwatch_band: '',
                    iwatch_condition: '',
                    iwatch_functional: '',
                    iwatch_powercord: '',
                    iwatch_box: '',
                    iwatch_bands: ''
                }}
                onSubmit={handelSubmits}
            >
                {({ values, handleChange }) => (
                    <Form>
                        <div className="">
                            {selectedDevice && selectedDevice[0].displayName &&
                                <div className="">
                                    <div className="d-flex align-items-center">
                                    <div className="border border-dark rounded mx-2 my-2 p-2 bg-white justify-content-center" >
                                        <img  className="bg-white"height="50" src={selectedDevice[0].imagePath}>
                                        </img>
                                        <div>
                                        <span style={{fontSize:13, fontFamily:''}}>{selectedDevice[0].displayName}</span>
                                        </div>
                                      
                                         </div> 
                                         <button className="border rounded-lg ml-2"
                                         
                                            onClick={(e) => {
                                            handleChange({
                                                target: {
                                                    name: "iwatch_model",
                                                    value: '',
                                                }
                                            })
                                            handleChange({
                                                target: {
                                                    name: "iwatch_carrier",
                                                    value: '',
                                                }
                                            })
                                            handleChange({
                                                target: {
                                                    name: "iwatch_edition_casing",
                                                    value: '',
                                                }
                                            })
                                            handleChange({
                                                target: {
                                                    name: "iwatch_size",
                                                    value: '',
                                                }
                                            })
                                            handleChange({
                                                target: {
                                                    name: "iwatch_bands",
                                                    value: '',
                                                }
                                            })
                                            handleChange({
                                                target: {
                                                    name: "iwatch_band",
                                                    value: '',
                                                }
                                            })
                                            handleChange({
                                                target: {
                                                    name: "iwatch_condition",
                                                    value: '',
                                                }
                                            })
                                            handleChange({
                                                target: {
                                                    name: "iwatch_functional",
                                                    value: '',
                                                }
                                            })
                                            handleChange({
                                                target: {
                                                    name: "iwatch_powercord",
                                                    value: '',
                                                }
                                            })
                                            handleChange({
                                                target: {
                                                    name: "iwatch_box",
                                                    value: '',
                                                }
                                            })
                                            setIsShowButton(false)
                                            setIsIncludesBand(false)
                                            setIsTypeOfWathches(false)
                                            setIsIncludesBandYes(false)
                                            setIsBrokenFiled(false)
                                            setIsBrokenOrNo(false)
                                            setSelectedDevice()
                                            setOffers()
                                            setIsLoader(false);
                                        }} ><span className="ml-3"> <EditIcon/> 
                                        </span> 
                                        <span className="ml-1 cursor-pointer text-info " > Change iWatch model</span>
                                        </button>
                                    </div>
                                    <hr />
                                    {
                                        !values.iwatch_carrier && selectedDevice[0].displayName != "Apple Watch Ultra 2"&& selectedDevice[0].displayName !="Apple Watch Ultra" && 
                                        <>
                                           
                                            <div>
                                            <span style={{fontSize:20, fontWeight:500}}>Select connectivity of iWatch: </span>
                                            </div>

                                          <div role="group" aria-labelledby="my-radio-group">
                                        <div className="grid-container d-flex">
                                                    {selectedDevice[0].deviceDetail[0].TypeOfWathches.map((x, i) => (
                                                        <div className="">
                                                            <label className="border border-dark w-70 cursor-pointer rounded p-2">
                                                                <Field className="d-none"  type="radio" name="iwatch_carrier" value={x} onClick={setIsTypeOfWathches(true)} />
                                                                <div>
                                                                <span>{x}</span>  
                                                                    {x === 'GPS+' &&
                                                                      <span> Cellular</span> || null
                                                                    }
                                                                </div>
                                                            </label>
                                                        </div>))
                                                    }
                                                </div>
                                            </div>
                                        </>
                                    }

                                    {
                                          selectedDevice[0].displayName != "Apple Watch Ultra 2"&& selectedDevice[0].displayName !="Apple Watch Ultra" &&  values.iwatch_carrier
                                          &&<>
                                            
                                            <div className="d-flex align-items-center">
                                            <div className="border border-dark rounded mx-2  p-2" >
                                            <span style={{fontSize:14}}>{values.iwatch_carrier}
                                                 </span>
                                                </div>  
                                                 <button className="border rounded-lg ml-2"
                                                
                                                 onClick={(e) => {
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_carrier",
                                                            value: '',
                                                        }
                                                    })

                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_edition_casing",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_size",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_band",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_bands",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_condition",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_functional",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_powercord",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_box",
                                                            value: '',
                                                        }
                                                    })

                                                    setOffers()
                                                    setIsShowButton(false)
                                                    setIsIncludesBand(false)
                                                    setIsIncludesBandYes(false)
                                                    setIsBrokenFiled(false)
                                                    setIsBrokenOrNo(false)

                                                }} ><span className="ml-3">
                                                <EditIcon/></span> 
                                                <span className="ml-1 cursor-pointer text-info ">  Change connectivity of iWatch</span>
                                                </button>
                                            </div>
                                        </>
                                    }

                                    {
                                        selectedDevice[0].deviceDetail && !values.iwatch_edition_casing && (isTypeOfWathches && values.iwatch_carrier ? true : !isTypeOfWathches && !values.iwatch_carrier ? true : false) && selectedDevice[0].deviceDetail[1].TypeofCaseWatchHave && selectedDevice[0].deviceDetail[1].TypeofCaseWatchHave.length > 0 &&
                                        <>
                                            <hr />
                                            <div>
                                            <span style={{fontSize:20, fontWeight:500}}>Select type of case watch have: </span>
                                            </div>

                                            <div className="">
                                                {
                                                    selectedDevice[0].deviceDetail[1].TypeofCaseWatchHave.map((x, i) => (
                                                        <div className="grid-container" key={i} role="group" aria-labelledby="my-radio-group">
                                                             
                                                                
                                                                <label  style={{fontSize:18}} className="mt-1">
                                                                <div className="border border-dark w-70 rounded-lg  p-2 text-center" >
                                                                <Field className="d-none" type="radio" name="iwatch_edition_casing" value={x} />
                                                               
                                                                    {x}
                                                                </div>
                                                                </label>
                                                            </div>
                                                       
                                                    ))
                                                }
                                            </div>
                                        </>
                                    }

                                    {
                                        values.iwatch_edition_casing &&
                                        <>
                                            <hr />
                                            <div className="d-flex align-items-center">
                                            <div className="border border-dark rounded mx-2  p-2" >
                                            <span style={{fontSize:14}}>{values.iwatch_edition_casing}</span>
                                            </div>
                                                
                                                <button  style={{fontSize:14}} className="border rounded-lg ml-2"
                                                 onClick={(e) => {
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_edition_casing",
                                                            value: '',
                                                        }
                                                    }) 
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_size",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_band",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_bands",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_condition",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_functional",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_powercord",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_box",
                                                            value: '',
                                                        }
                                                    })

                                                    setOffers()
                                                    setIsShowButton(false)
                                                    setIsIncludesBand(false)
                                                    setIsIncludesBandYes(false)
                                                    setIsBrokenFiled(false)
                                                    setIsBrokenOrNo(false)
                                                }} > 
                                                <span className="ml-3">
                                                <EditIcon/></span> 
                                                <span className="ml-1 cursor-pointer text-info "> Change type of iWatch case</span>
                                                </button>
                                            </div>
                                        </>
                                    }
                                    {selectedDevice[0].deviceDetail && (selectedDevice[0].displayName != 'Apple Watch Series 1' ? (values.iwatch_edition_casing ? true : false) : true) && !values.iwatch_size && selectedDevice[0].deviceDetail[2].SizeofyourWatch && selectedDevice[0].deviceDetail[2].SizeofyourWatch.length > 0 &&
                                        <>
                                            <hr />
                                            <div>
                                            <span style={{fontSize:20, fontWeight:500}}>Select size of your iWatch:</span>
                                            </div>
                                            <div role="group" aria-labelledby="my-radio-group">
                                            <div className="grid-container d-flex">
                                                    {
                                                        selectedDevice[0].deviceDetail[2].SizeofyourWatch.map((x, i) => (
                                                            <label key={i} className="border border-dark text-center cursor-pointer rounded w-50 p-2">
                                                                <Field className="d-none" type="radio" name="iwatch_size" onChange={handleChange} value={x} />
                                                                {x}
                                                            </label>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        </>
                                    }

                                    {
                                        (selectedDevice[0].displayName != 'Apple Watch Series 1' ? (values.iwatch_edition_casing ? true : false) : true) && values.iwatch_size &&
                                        <>
                                            <hr />
                                            <div className="d-flex align-items-center">
                                                <div className="border border-dark rounded mx-2  p-2" >
                                                    <span style={{fontSize:14}}> 
                                                        {values.iwatch_size}
                                                    </span>
                                                </div>  
                                                <button className="border rounded-lg ml-2" onClick={(e) => {
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_size",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_condition",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_band",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_bands",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_functional",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_powercord",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_box",
                                                            value: '',
                                                        }
                                                    })

                                                    setOffers()
                                                    setIsShowButton(false)
                                                    setIsIncludesBand(false)
                                                    setIsIncludesBandYes(false)
                                                    setIsBrokenFiled(false)
                                                    setIsBrokenOrNo(false)

                                                }}>
                                                 <span className=""> <EditIcon/> </span>
                                         <span className="ml-1 cursor-pointer text-info" > Change size of your iWatch</span>
                                         </button>
                                            </div>
                                        </>
                                    }
                                    
                                    
                                    


                                    {selectedDevice[0].deviceDetail  && !values.iwatch_condition && selectedDevice[0].deviceDetail[4].Condition && selectedDevice[0].deviceDetail[4].Condition.length > 0 && ((selectedDevice[0].displayName != 'Apple Watch Ultra' ? (values.iwatch_edition_casing ? true : false) : true)
                                      || (selectedDevice[0].displayName != 'Apple Watch Ultra 2' ? (values.iwatch_edition_casing ? true : false) : true))&& ((selectedDevice[0].displayName != 'Apple Watch Ultra' ? (values.iwatch_size ? true : false) : true)
                                      || (selectedDevice[0].displayName != 'Apple Watch Ultra 2' ? (values.iwatch_size ? true : false) : true))&& <>
                                            <hr />
                                            
                                            <div className="ml-2">
                                            <span style={{fontSize:20, fontWeight:500}}>Select cosmetic condition of your iWatch</span>
                                            </div>
                                            {/*Modal trigger */} 
                                            <a type="link" data-toggle="modal" data-target="#exampleModalCenter">
                                            <span style={{fontSize:14}}className="ml-2 text-danger cursor-pointer"><u>Learn more about how to determine the condition of the iWatch?</u></span></a>
                                                        {/*Modal */} 
                                                        <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                                            <div class="modal-dialog modal-dialog-centered" role="document">
                                                                <div class="modal-content">
                                                                    <div class="modal-header">
                                                                        <h5 class="modal-title" id="exampleModalLongTitle">Determine the cosmetic conditions of your iWatch</h5>
                                                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                                        <span aria-hidden="true">&times;</span>
                                                                        </button>
                                                                    </div>
                                                                    <div class="modal-body">
                                                                        <p>It is important to accurately rate the physical and functional condition of your item. These conditions are crucial to helping sell my device  meet your expectations.</p>
                                                                        <p><strong>Brand new (if all of the following is true):</strong>
                                                                            <ul>
                                                                                <li> Your iWatch is still in original packaging and sealed in the box which also includes all the accessories comes inside it.</li>
                                                                                <li> Your iWatch is untouched.</li>
                                                                                <li> iWatch's box never been opened.</li>
                                                                            </ul>
                                                                        </p>
                                                                        <p><strong>Flawless (if the following is true):</strong>
                                                                            <ul>
                                                                                <li> Your iWatch and band have absolutely no scratches,scuffs or other marks. </li>
                                                                                <li>Your iWatch Looks brand new and in mint condition'</li>
                                                                                <li> Your iWatch must not have any sign of water damage or stains on outer body.</li>
                                                                            </ul>
                                                                        </p>
                                                                        <p><strong>Good (if the following is true):</strong>
                                                                        <ul>
                                                                                <li> Your iWatch is in working order with light to moderate signs of wear.</li>
                                                                                <li>Your iWatch contains few light scratches, dings, or wear on screen and band..</li>
                                                                                <li> Your iWatch must not have any sign of water damages.</li>
                                                                            </ul>
                                                            
                                                                        </p>
                                                                        <p><strong>Fair (if the following is true):</strong>
                                                                       
                                                                            <ul>
                                                                                <li>  Your iWatch is in working order with moderate to excessive signs of wear.</li>
                                                                                <li> iWatch Contains heavy scratches and/or dents on screen and band..</li>
                                                                                <li> iWatch must not have any sign of water damages.</li>
                                                                            </ul>
                                                            
                                                                        </p>
                                                                        <p><strong>Broken (if any of the following is true):</strong>
                                                                
                                                                            <ul>
                                                                                <li> Does not power on.</li>
                                                                                <li> Broken or cracked LCD screen or glass.</li>
                                                                                <li>  Missing buttons (power, home, ringer, volume).</li>
                                                                                <li> Broken or cracked hardware (charging ports, casing, etc.)
                                                                                Housing separation beyond the width of a nickel,
                                                                                have signs of water damages.</li>
                                                                            </ul>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>   
                                                       <>
                                                                                                               
                                                    <div>
                                                         <div role="group" className="grid-container" aria-labelledby="my-radio-group">
                                                            <div>
                                                            <div className= {` ${values.condition=== "Brand New"&&'grid-item1-bg'|| 'grid-item1'} `}>
                                                                <div className="d-flex justify-content-between">
                                                                            <label className="h7"><strong>Brand New</strong> </label>
                                                                                    <Field className="mt-1" type="radio" name="iwatch_condition" value='Brand New'  onClick={()=>scrollToSection(section1Ref)}/>
                                                                </div>
                                                                    <hr></hr>
                                                                    <label className="">
                                                                    <span style={{fontSize:14}} className="extra-txt ng-binding" ng-show="answer.tooltip.length"> 
                                                                    <span style={{fontSize:15, fontWeight:500}}>All of the below is true </span>
                                                                            <ul>
                                                                                <li>Sealed in the original company packaging.</li>
                                                                                <li>Comes with all the accessories inside.</li>
                                                                                <li>Warranty hasn't been activated on it yet.</li>
                                                                
                        
                                                                            </ul>
                                                                            
                                                                        </span>
                                                                    </label>
                                                            </div>
                                                            </div>
                                                            <div>
                                                            <div className= {` ${values.condition=== "Like New"&&'grid-item1-bg'|| 'grid-item1'} `}>
                                                            <div className="d-flex justify-content-between">
                                                                    <label className="h7"> <strong>Like New</strong></label>
                                                                    <Field className="mt-1" type="radio" name="iwatch_condition" value='Like New' onClick={()=>scrollToSection(section1Ref)}/>
                                                            </div>
                                                                <hr></hr>
                                                                    <label className="">
                                                                    <span style={{fontSize:14}} className="extra-txt ng-binding" ng-show="answer.tooltip.length"> 
                                                                    <span style={{fontSize:15, fontWeight:500}}>All of the below is true </span>
                                                                            <ul>
                                                                                <li>Everything works fine.</li>
                                                                                <li>Immaculate cosmetic condition.</li>
                                                                                <li>Not a single scuffs and/or dents of any kind on anywhere.</li>                                                                
                        
                                                                            </ul>
                                                                            
                                                                        </span>
                                                                    </label>
                                                            </div>
                                                            </div>
                                                        <div>
                                                        <div className= {` ${values.condition=== "Good"&&'grid-item1-bg'|| 'grid-item1'} `}>
                                                                    <div className="d-flex justify-content-between">
                                                                        <label className="h7"><strong>Good</strong> </label>
                                                                        <Field className="mt-1" type="radio" name="iwatch_condition" value='Good' onClick={()=>scrollToSection(section1Ref)}/>
                                                                    </div>
                                                                    <hr></hr>
                                                                    <label className="">
                                                                    <span style={{fontSize:14}} className="extra-txt ng-binding" ng-show="answer.tooltip.length"> 
                                                                    <span style={{fontSize:15, fontWeight:500}}>All of the below is true </span>
                                                                            <ul>
                                                                                <li>Everything works fine.</li>
                                                                                <li>Minor wear barely noticable scuffs or/and chips.</li>
                                                                                <li>May have single scuff/scratch on the outer body but not on the display/screen.</li>
                                                                                <li>Must not have any dents or deep scratches.</li>
                                                                            </ul>
                                                                            
                                                                        </span>
                                                                    </label>
                                                                    </div>
                                                        </div>
                                                                    <div>
                                                                    <div className= {` ${values.condition=== "Fair"&&'grid-item1-bg'|| 'grid-item1'} `}>
                                                                                    <div className="d-flex justify-content-between">
                                                                                        <label className="h7"> <strong>Fair</strong></label>
                                                                                    <Field className="mt-1" type="radio" name="iwatch_condition" value='Fair'  onClick={()=>scrollToSection(section1Ref)}/>
                                                                                    </div>
                                                                                    <hr></hr>
                                                                                    <label className="">
                                                                                    <span style={{fontSize:14}} className="extra-txt ng-binding" ng-show="answer.tooltip.length"> 
                                                                                        <span style={{fontSize:15, fontWeight:500}}>All of the below is true </span>
                                                                                        
                                                                                        <ul>
                                                                                            <li>Everything works fine.</li>
                                                                                            <li> Moderate to heavy wear with deep scuffs and/or dents on outer body and/or on Display.</li>
                                                                                        </ul>
                                                                                    </span>
                                                                                        
                                                                                    </label>
                                                                                </div>
                                                                    </div>
                                                                    <div>
                                                                    <div className= {`${values.condition=== "Broken"&&'grid-item1-bg'|| 'grid-item1'} `}>
                                                                                                <div className="d-flex justify-content-between">
                                                                                                    <label className="h7"> <strong>Broken</strong></label>
                                                                                                <Field className="mt-1" type="radio" name="iwatch_condition" value='Broken'  onClick={()=>scrollToSection(section1Ref)}/>
                                                                                                </div>
                                                                                                <hr></hr>
                                                                                                <label className="">
                                                                                                <span style={{fontSize:14}} className="extra-txt ng-binding" ng-show="answer.tooltip.length"> 
                                                                                                    <span style={{fontSize:15, fontWeight:500}}>Any of the below is true </span>
                                                                                                    
                                                                                                    <ul>
                                                                                                        <li>Does not power on.</li>
                                                                                                        <li>Battery expanding, LCD or Display shattered/cracked.</li>
                                                                                                        <li>May have funcationality issues.</li>
                                                                                                        <li>Falling apart from the back or display.</li>
                                                                                                    </ul>
                                                                                                </span>
                                                                                                    
                                                                                                </label>
                                                                                            </div>
                                                                    </div>
                                                                   
                                                                                                    
                                                                     
                                                        
                                                                </div>
                                                        </div> 
                                                                                                                   </>

                                        </>
                                    }

                                    {
                                         values.iwatch_condition && 
                                        <>
                                            <hr />
                                            <div className="d-flex align-items-center">
                                               
                                                <div className="border border-dark rounded mx-2  p-2" >
                                                <span style={{fontSize:14}}> 
                                                    {values.iwatch_condition}
                                                    </span>
                                                    </div>
                                                    <button className="border rounded-lg ml-2"
                                                onClick={(e) => {
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_condition",
                                                            value: '',
                                                        }
                                                    }) 
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_bands",
                                                            value: '',
                                                        }
                                                    })
                                                     handleChange({
                                                        target: {
                                                            name: "iwatch_functional",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_powercord",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_box",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_band",
                                                            value: '',
                                                        }
                                                    })
                                                    setOffers()
                                                    setIsShowButton(false)
                                                    setIsIncludesBand(false)
                                                    setIsBrokenOrNo(false)
                                                    setIsBrokenFiled(false)
                                                }}> <span className="ml-3">
                                                    <EditIcon/>
                                                    </span>
                                                    <span className="ml-1 cursor-pointer text-info ">
                                                        Change condition of the iWatch
                                                    </span>
                                                    </button>
                                            </div>
                                        </>
                                    }

                                    {
                                        !values.iwatch_band  && values.iwatch_condition &&values.iwatch_condition !="Brand New"&&
                                        <>
                                            <hr />
                                            <div>
                                            <span style={{fontSize:20, fontWeight:500}}>Is your iWatch includes band? </span>
                                            </div>
                                             <>
                                                <div className="grid-container" role="group" aria-labelledby="my-radio-group">                                                        
                                                        <label style={{fontSize:22, fontWeight:500}}className="mt-1">
                                                        <div className="border border-dark w-70 rounded-lg  text-center" >
                                                        
                                                            Yes
                                                            </div>
                                                            <Field className="d-none"type="radio"  name="iwatch_band" onClick={(setIsIncludesBand(true))}value='Yes' />
                                                            </label>
                                                        
                                                    
                                                    
                                                        
                                                        <label style={{fontSize:22, fontWeight:500}}className="mt-1">
                                                        <div className="border border-dark w-70 rounded-lg  text-center" >
                                                                No
                                                        </div>
                                                            <Field className="d-none" type="radio" name="iwatch_band"onClick={(setIsIncludesBand(false))} value='No' />
                                                            </label>
                                                        
                                                    
                                                </div>
                                            </>
                                                                            
                                            
                                        </>
                                    }

                                    {
                                        values.iwatch_band && values.iwatch_condition  &&
                                        <>
                                            <hr />
                                            <div className="d-flex align-items-center">
                                            <div className="border border-dark rounded mx-2  p-2" >
                                            <span style={{fontSize:14}}>{values.iwatch_band}
                                                        </span>
                                                        </div>
                                                <button className="border rounded-lg ml-2" 
                                               
                                                 onClick={(e) => {
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_band",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_bands",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_functional",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_powercord",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_box",
                                                            value: '',
                                                        }
                                                    })
                                                    setOffers()
                                                    setIsBrokenOrNo(false)
                                                    setIsShowButton(false)
                                                    setIsIncludesBandYes(false)
                                                }} > <span className="ml-3">
                                                <EditIcon/>
                                                </span> 
                                               
                                                <span className="ml-1 cursor-pointer text-info" >  Change band includes</span>
                                                </button>
                                            </div>
                                        </>
                                    }
                                    {
                                        !values.iwatch_bands && ((selectedDevice[0].displayName != 'Apple Watch Ultra' ? (values.iwatch_size ? true : false) : true)&&(values.iwatch_condition?true:false )&& values.iwatch_band==="Yes"
                                        || (selectedDevice[0].displayName != 'Apple Watch Ultra 2' ? (values.iwatch_size ? true : false) : true)) && values.iwatch_condition !="Brand New" &&(values.iwatch_condition?true:false) && values.iwatch_band==="Yes"&&
                                        <>
                                            <hr />
                                            <span style={{fontSize:20, fontWeight:500}}>What type of the band is iWatch comes with?</span>
                                            <div className="grid-container">
                                               
                        
                                                    {selectedDevice[0].deviceDetail[3].TypeOfBands.map((x, i) => (
                                                        
                                                        
                                                        
                                                           <>
                                                          
                                                                {x !=="Not sure"&&
                                                                    <label  style={{fontSize:17}} className="mt-1">
                                                                    <div className="border border-dark rounded-lg p-2 text-center" >
                                                                         <Field className="d-none" type="radio" name="iwatch_bands" value={x} />
                                                                         {x}
                                                                         </div>
                                                                         </label>
                                                                }

                                                                {x ==="Not sure"&&
                                                                   
                                                                    <label  style={{fontSize:17}} className="mt-1">
                                                                    <div className="border border-dark rounded-lg p-2 text-center" >
                                                                         <Field className="d-none" type="radio" name="iwatch_bands" value={selectedDevice[0].deviceDetail[3].TypeOfBands[0]} />
                                                                         {x}
                                                                         </div>
                                                                         </label>
                                                                        
                                                                }
                                                          
                                                               
                                                          </>
                                                      
                                                   
                                                       
                                                        ))
                                                    }
                                              
                                            
                                                          
                                                    </div>
                                                    
                                        </>
                                    }

                                    {values.iwatch_bands&&
                                        <>
                                            <hr />
                                            <div className="d-flex align-items-center">
                                            <div className="border border-dark rounded mx-2  p-2" >

                                                     <span style={{fontSize:13, fontFamily:''}}>
                                                        {values.iwatch_bands ? values.iwatch_bands : values.iwatch_band}
                                                    </span>
                                                    </div>
                                                    <button className="border rounded-lg ml-2"
                                                    onClick={(e) => {
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_bands",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_functional",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_powercord",
                                                            value: '',
                                                        }
                                                    })
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_box",
                                                            value: '',
                                                        }
                                                    })
                                                    setOffers()
                                                    setIsShowButton(false)
                                                    setIsBrokenOrNo(false)
                                                }}> <span><EditIcon></EditIcon></span>
                                                <span className="ml-1 cursor-pointer text-info ">   Change type of band</span>
                                                </button>
                                            </div>
                                        </>
                                    }

                                    {
                                        !values.iwatch_functional &&( values.iwatch_band!="No"?(values.iwatch_bands?true:false):true)&&(values.iwatch_condition?true:false )&&
                                        <>
                                            <hr />
                                            <div>
                                            <span style={{fontSize:20, fontWeight:500}}>Is your iWatch fully functional?</span>
                                            </div>
                                            <>
                                                                                    <div className="grid-container" role="group" aria-labelledby="my-radio-group">
                                                                                       
                                                                                            
                                                                                            <label style={{fontSize:22, fontWeight:500}}className="mt-1">
                                                                                            <div className="border border-dark w-70 rounded-lg  text-center" >
                                                                                                Yes
                                                                                               
                                                                                                    <Field className="d-none" type="radio" onClick={() => {
                                                                                                        setIsWatch_functionalYes(true)
                                                                                                        setIsShowButton(true)
                                                                                                    }
                                                                                                    } name="iwatch_functional" value='Yes' />
                                                                                            </div>
                                                                                            </label>
                                                                                            
                                                                                       
                                                                                      
                                                                                       
                                                                                            
                                                                                            <label style={{fontSize:22, fontWeight:500}}className="mt-1">
                                                                                            <div className="border border-dark w-70 rounded-lg  text-center" >
                                                                                                No
                                                                                                <Field className="d-none" onClick={() => {
                                                                                                    setIsWatch_functionalYes(false)
                                                                                                    setIsShowButton(true)
                                                                                                    setIsBrokenOrNo(true)
                                                                                                }} type="radio" name="iwatch_functional" value='No' />
                                                                                                <Field className="d-none" type="radio" name="powercord" value='No' />
                                                                                                </div>
                                                                                            </label>
                                                                                            
                                                                                       
                                                                                    </div>
                                                                                </>
                                                                             </>
                                    }

                                    {
                                       values.iwatch_functional &&  values.iwatch_condition && 
                                        <>
                                            <hr />
                                            <div className="d-flex align-items-center">
                                                
                                                <div className="border border-dark rounded mx-2  p-2" >
                                                <span style={{fontSize:14}}> {values.iwatch_functional}</span>
                                                    </div>
                                                <button className="border rounded-lg ml-2"
                                                 onClick={(e) => {
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_functional",
                                                            value: '',
                                                        }
                                                    })
                                                    setOffers()
                                                    setIsShowButton(false)
                                                    setIsBrokenOrNo(false)
                                                }} > <span><EditIcon></EditIcon></span>
                                                    <span className="ml-1 cursor-pointer text-info "> Change funcationality</span>
                                                    </button>
                                            </div>
                                        </>
                                    }

                                    {
                                        isEmpty(offers) && values.iwatch_functional && isWatch_functionalYes && values.iwatch_condition  && values.iwatch_band &&
                                        <>
                                            <hr />
                                            <div>
                                            <span style={{fontSize:20, fontWeight:500}}>Select your iWatch's accessories included</span>
                                            </div>

                                            {
                                                isEmpty(offers) &&
                                                <div className="row">
                                                    <div className="grid-container">
                                                        <div className="border border-dark text-center cursor-pointer rounded  p-2">
                                                            <div className="float-right">
                                                                <Field className="ml-2 mt-2" onChange={handleChange} checked={values.iwatch_box} type="checkbox" name="iwatch_box"  />
                                                            </div>
                                                            <label className="mt-1">
                                                                Have Oringinal box
                                                        </label>
                                                        </div>
                                                        <div className="border border-dark text-center cursor-pointer rounded  p-2">
                                                            <div className="float-right">
                                                                <Field className="ml-2 mt-2" onChange={handleChange} type="checkbox" checked={values.iwatch_powercord} name="iwatch_powercord" />
                                                            </div>
                                                            <label className="mt-1">
                                                                Charging cable and adaptor
                                                        </label>
                                                        </div>
                                                    </div>
                                                </div>

                                            }
                                        </>
                                    }

                                    {
                                         values.iwatch_functional && isWatch_functionalYes  && values.iwatch_band && !isEmpty(offers) &&
                                        <>
                                            <hr />
                                            
                                            <div className="d-flex align-items-center">
                                                
                                                <div className="border border-dark rounded mx-2  p-2" >
                                                    <span style={{fontSize:13, fontFamily:''}}>{values.iwatch_box && "Yes" || "No"}</span> 
                                                </div> 
                                                <button className="border rounded-lg ml-2"
                                                 onClick={(e) => {
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_box",
                                                            value: '',
                                                        }
                                                    })
                                                    setOffers()
                                                    setIsBrokenOrNo(false)
                                                }} ><span><EditIcon></EditIcon></span> 
                                                <span className="ml-1 cursor-pointer text-info h">Change box included. </span>
                                                </button>
                                            </div>
                                                <hr/>
                                            <div className="d-flex align-items-center">
                                             <div className="border border-dark rounded mx-2  p-2" >
                                                <span style={{fontSize:15, fontFamily:''}}>{values.iwatch_powercord && "Yes" || "No"}</span>
                                            </div>
                                            
                                            <button className="border rounded-lg ml-2"
                                                 onClick={(e) => {
                                                    handleChange({
                                                        target: {
                                                            name: "iwatch_powercord",
                                                            value: '',
                                                        }
                                                    })
                                                    setOffers()
                                                    setIsBrokenOrNo(false)
                                                }} > <span><EditIcon></EditIcon></span> 
                                                <span className="ml-1 cursor-pointer text-info h">Change cable included. </span>
                                                </button>
                                            </div>
                                        </>
                                    }
                                </div>
                            }

                            {
                                isEmpty(offers) && !isBrokenFiled && !isBrokenOrNo && (values.iwatch_condition === 'Brand New' || isShowButton || (values.iwatch_functional && isWatch_functionalYes  && values.iwatch_condition && values.iwatch_size && values.iwatch_band)) &&
                                <div className="col-md-12">
                                    <div className="d-flex justify-content-center">
                                        <div className="col-md-6 mt-4 text-center">
                                            <Button variant="outline-secondary" className="w-100" type="submit">Show my Offer</Button>
                                        </div>
                                    </div>
                                </div>
                            }

                            {
                                isBrokenFiled && isShowButton &&
                                <div className="col-md-12">
                                    <div className="d-flex justify-content-center">
                                        <div className="col-md-6 mt-4 text-center">
                                            <Button variant="outline-secondary" className="w-100" onClick={() => {
                                                setIsBrokenOrNo(true)
                                                setIsBrokenFiled(false)
                                            }} >Show my Offer</Button>
                                        </div>
                                    </div>
                                </div>
                            }

                            {isLoader && isEmpty(offers) &&
                                <div className="text-center col-md-12">
                                    <LoaderSpinner></LoaderSpinner>
                                </div>

                            }

                            {!isEmpty(offers) && !isBrokenOrNo &&
                            <>
                                <hr/>
                                <div className="mt-4 col-md-12 text-center">
                                    <div className="d-flex justify-content-center">
                                        <div className="col-md-2">
                                            <h1 className="border p-4 m-0">
                                                $ {offers[0].offer}
                                            </h1>
                                            <div className="border-right p-1 border-bottom border-left">
                                                <h5 className="mt-1">Your Offer </h5>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-center">
                                        <div className="mt-4 col-md-6">
                                            <Button variant="outline-primary" className="w-100" onClick={() => addCart(offers[0])} type="submit">Sell Now</Button>
                                        </div>
                                    </div>
                                    <div className="mt-3 mx-2"style={{fontSize: "14px"}}>
                                        *Offered value of the device is subject to device review 
                                        We may requote you with higher offer value if we find the cosmetic condition of the device better than what you thought of and vice versa.
                                       We process the payment immediately after receiving your device we offer free express shipping. 
                                        We don’t pay for the devices that have been reported lost or stolen
                                    </div>
                                </div>
                                </>
                            }

                            {isBrokenOrNo &&
                                    <div className="border rounded-lg mt-4 col-md-12 text-center">
                                    <div className="mt-3 bg-custom-danger">
                                    <p className="mx-3,my-3">Currently we’re not able to offer any value for the selected device in described condition but 
                                        we can safely recycle it in a way which won’t harm environment in any way and leave zero carbon footprint.
                                        you can either proceed to recycle now or simply keep the device with you,
                                        and checkout value of other devices if you're looking to sell them as well.
                                       </p>

                                    </div>
                                    <div className="d-flex justify-content-center">
                                        <div className="mt-4 col-md-6">
                                            <Button variant="outline-primary" className="w-100" onClick={() => addCart({
                                                iwatch_band: values.iwatch_bands,
                                                iwatch_box: values.iwatch_box,
                                                iwatch_carrier: values.iwatch_carrier,
                                                iwatch_condition: values.iwatch_condition,
                                                iwatch_edition_casing: values.iwatch_edition_casing,
                                                iwatch_functional: values.iwatch_functional,
                                                iwatch_model: selectedDevice[0].label,
                                                iwatch_powercord: values.iwatch_powercord,
                                                iwatch_size: values.iwatch_size,
                                                offer: 0,
                                                id: selectedDevice[0].label
                                            })}>Recycle now</Button>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-center">
                                        <div className="mt-4 col-md-6">
                                            <Button variant="outline-primary" className="w-100" onClick={() => {{window.location.href="/sellADevice"}}}
                                            >Check values of other devices</Button>

                                        </div>
                                    </div>


                                </div>
                            }

                        </div>
                    </Form>
                )}
            </Formik>
        </div >
    )
}

export default IWatch
